import store from '../store';
import moment from 'moment';
// import qs from 'qs'
import {
  v4 as uuidv4
} from 'uuid';
import { AI_MODEL_CONSTANTS } from './constants.js';
import { handleCreateAppError } from '@/common/quotaError.js';
// 改为按需异步加载，减少初始打包体积
// import {
//   utils,
//   writeFileXLSX
// } from 'xlsx';
import {
  saveAs
} from 'file-saver';
import Recorder from 'recorder-core';
import 'recorder-core/src/engine/wav';
import {
  Loading
} from 'element-ui';
// 改为按需异步加载，减少初始打包体积
// const pdfMake = require('pdfmake');
// import {
//   remark
// } from "remark";
// import strip from "strip-markdown";
import _ from "lodash";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import WavEncoder from "wav-encoder";
import WaveSurfer from 'wavesurfer.js';
// import MicrophonePlugin from 'wavesurfer.js/dist/plugin/wavesurfer.microphone.js';
import RecordPlugin from 'wavesurfer.js/dist/plugins/record.esm.js';
export const myMixin = {
  data() {
    return {
      speechRecognizer:null,
      execution_times:0,
      timer:null,
      isRunning:false,
      seconds:0,
      reply_round:0,
      model_list: [],
      model_list_cn: [],
      model_list_en: [],
      agentRecorder: null,
      choice_question_index: 0,
      muti_default_avatar:[
				'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2F%E9%BB%98%E8%AE%A4%E5%A4%B4%E5%83%8F51741770599274.svg',
        'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/muti_default_avatar1741419615891.svg',
        'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/muti_default_avatar21741419755186.svg'
      ],
      agent_default_avatar:[
				'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2F%E9%BB%98%E8%AE%A4%E5%A4%B4%E5%83%8F11741770951146.png',
				'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2F%E9%BB%98%E8%AE%A4%E5%A4%B4%E5%83%8F21741770979182.png',
				'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2F%E9%BB%98%E8%AE%A4%E5%A4%B4%E5%83%8F31741771004987.png',
				'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2F%E9%BB%98%E8%AE%A4%E5%A4%B4%E5%83%8F41741771020221.png',
				'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2F%E9%BB%98%E8%AE%A4%E5%A4%B4%E5%83%8F71741771071907.png',
				'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2F%E9%BB%98%E8%AE%A4%E5%A4%B4%E5%83%8F61741771089947.png'
      ],
      wavesurfer: null,
      record: null,
      isRecording: false,
      isPlayingAudio: false,
      // Streaming TTS state
      ttsQueue: [],
      ttsBusy: false,
      isTtsStreaming: false,
      ttsPlayer: null,
      ttsSynthesizer: null,
      ttsBuffer: '',
      // Initialize arrays used later to avoid undefined access
      answer_arr: [],
      OPUserJson: {}
    }
  },
  computed:{
    audioConfig(){
      try {
        return SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
      } catch (error) {
        console.error('创建 audioConfig 失败:', error);
        return null;
      }
    },
    speechConfig(){
      try {
        const key = process.env.VUE_APP_AZURE_SPEECH_KEY;
        const region = process.env.VUE_APP_AZURE_SPEECH_REGION;

        if (!key || !region) {
          console.error('Azure Speech 环境变量未设置:', { key: !!key, region: !!region });
          return null;
        }

        console.log('[speechConfig] 使用环境变量:', { key: key.substring(0, 8) + '...', region });
        return SpeechSDK.SpeechConfig.fromSubscription(key, region);
      } catch (error) {
        console.error('创建 speechConfig 失败:', error);
        return null;
      }
    },
    autoDetectSourceLanguageConfig(){
      try {
        return SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages([
          "zh-CN",
          "en-US", // 添加英文支持
        ]);
      } catch (error) {
        console.error('创建 autoDetectSourceLanguageConfig 失败:', error);
        return null;
      }
    }
  },
  watch:{
    seconds(newValue){
      //console.log(newValue)
      for(let condition in this.mon_agent_properties.trigger_condition){
        const time = this.timeToSeconds(this.mon_agent_properties.trigger_condition[condition].option_value);
        switch (this.mon_agent_properties.trigger_condition[condition].logical_option_value) {
          case "等于":
            if(newValue==time){
              this.is_mon_agent=true;
              this.mon_agent_update++;
            }
            break;
          case "每隔":
            if(this.isDivisible(newValue,time)){
              this.is_mon_agent=true;
              this.mon_agent_update++;
            }
            break;
          default:
            break;
        }
      }
    }
  },
  methods: {
    isDivisible(numerator, denominator) {
      if (denominator === 0) return;
      if (typeof numerator !== 'number' || typeof denominator !== 'number') {
          return false;
      }
      return numerator % denominator === 0;
    },
    timeToSeconds(timeStr) {
      // 分割时间字符串
      const parts = timeStr.split(':').map(Number);
      
      // 计算总秒数
      return parts[0] * 3600 + parts[1] * 60 + parts[2];
    },
    replaceLast(str, search, replacement) {
      // 反转字符串
      const reversedStr = str.split('').reverse().join('');

      // 反转搜索项和替换项（如果是字符串）
      const reversedSearch = search instanceof RegExp ? new RegExp(search.source.split('').reverse().join(''), 'g') : search.split('').reverse().join('');
      const reversedReplacement = replacement.split('').reverse().join('');

      // 替换第一个匹配项（现在是最后一个，因为字符串是反转的）
      const replacedReversedStr = reversedStr.replace(reversedSearch, reversedReplacement);

      // 再次反转字符串
      return replacedReversedStr.split('').reverse().join('');
    },
    insert_operating_record(json_data) {
      let params = [{
        uid: this.user.userId,
        courseId: '',
        type: "cocoflow",
        content: json_data
      }]
      // const encoded = {};
      // for (const key in params[0]) {
      //   if (Object.hasOwnProperty.call(params[0], key)) {
      //     encoded[key] = encodeURIComponent(params[0][key]);
      //   }
      // }
      // params = qs.stringify([encoded]) //序列化post 参数
      this.$axios.post('https://pbl.cocorobo.cn/api/pbl/addCourseBehavior', params)
      // .then(res => {
      //   if (res.data == 1) {
      //     console.log('保存成功')
      //   } else {
      //     console.log('保存失败')
      //   }
      // }).catch(e => {
      //   console.log('保存失败')
      //   console.log(e)
      // })
    },
    detectBrowser() {
      const ua = navigator.userAgent;
    
      // 按优先级顺序检测
      if (ua.includes("Edg/") || ua.includes("Edge/")) {
        return "Microsoft Edge";
      } else if (ua.includes("Firefox")) {
        return "Mozilla Firefox";
      } else if (ua.includes("Trident") || ua.includes("MSIE")) {
        return "Internet Explorer";
      } else if (ua.includes("360EE")) {
        return "360 Browser (极速模式)";
      } else if (ua.includes("360SE")) {
        return "360 Browser (安全模式)";
      } else if (ua.includes("SLBrowser")) {
        return "QQ Browser";
      } else if (ua.includes("UCBrowser")) {
        return "UC Browser";
      } else if (ua.includes("Opera") || ua.includes("OPR/")) {
        return "Opera";
      } else if (ua.includes("Chrome") && !ua.includes("Edg/")) {
        return "Google Chrome";
      } else if (ua.includes("Safari/") && !ua.includes("Chrome")) {
        return "Safari";
      } else {
        return "Other Browser";
      }
    },
    async addOp2(text,appname, type){
			let userJson = {}
			try {
				userJson = await this.ajax.get(this.$store.state.api + "selectUser", { userid: this.user.userId });
				// console.log(userJson);
			} catch (e) {
				console.log(e);
        return setTimeout(()=>{
          return this.addOp2(text,appname, type)
        },10000)
				
			}
			let params = {
				accountNumber: userJson.data[0][0].accountNumber,
				username: this.user.userName,
				userid: this.user.userId,
				appname: appname,
				appid: text,
				status: type
			}
			this.ajax.post(this.$store.state.apiM + "updateUserData",[params]).then(res=>{
        if (res.data.status == 1) {
          console.log('保存成功')
        } else {
          console.log('保存失败')
        }
			}).catch(e=>{
          console.log('保存失败')
          console.log(e);
			})
		},
    async addOp3(userTime, loadTime, object, status, endTime, _retryCount = 0){
			const MAX_RETRY = 3;
			let userJson = this.OPUserJson;
			if (!userJson || !userJson.data || !userJson.data[0] || !userJson.data[0][0]) {
				try {
					userJson = await this.ajax.get(this.$store.state.api + "selectUser", { userid: this.user.userId });
					this.OPUserJson = userJson; // 缓存下来，避免下次重复获取
				} catch (e) {
					console.log(e);
					if (_retryCount >= MAX_RETRY) {
						console.warn('[addOp3] 达到最大重试次数，放弃请求');
						return;
					}
          return setTimeout(()=>{
            return this.addOp3(userTime, loadTime, object, status, endTime, _retryCount + 1);
          },10000)
				}
			}
      let _time = new Date().toLocaleString('zh-CN', { hour12: false, timeZone: 'Asia/Shanghai' }).replace(/\//g, '-');
      let browser = this.detectBrowser();
			let params = {
        userid: this.user.userId,
        username: this.user.userName,
        accountNumber: userJson.data[0][0].accountNumber,
        org: userJson.data[0][0].orgName,
        school: userJson.data[0][0].schoolName,
        role: userJson.data[0][0].type == '1' ? '老师' : '学生',
        browser: browser,
        userTime: userTime == '1' ? _time : userTime, // 使用时间 1次的就1 其次传秒
        loadTime: loadTime, //load的时间没有就"
        endTime: endTime == '1' ? _time : "", // 使用时间 1次的就1 其次传秒
        object: JSON.stringify(object), //执行信息传json
        status: status, //成功返回success。失败返回error的信息
			};
			this.ajax.post(this.$store.state.apiM + "updateUserData2", [params]).then(res => {
        if (res.data.status == 1) {
          console.log('保存成功');
        } else {
          console.log('保存失败');
        }
			}).catch(e => {
        console.log('保存失败');
        console.log(e);
			});
		},
    //导出为文件
    exportData(disposition) {
      let stringData = '';
      switch (disposition.export_range) {
        case this.lang.workspace:
          stringData = this.removeHTMLTags(this.work_area_text);
          break;
        default:
          this.aiChatMessages.forEach((item) => {
            stringData =
              stringData +
              this.removeHTMLTags(item.content) +
              '\n' + (item.fileid ? item.fileid : item.userName) + ":" +
              this.removeHTMLTags(item.aiContent) +
              '\n';
          });
          break;
      }
      switch (disposition.export_format) {
        case 'doc':
          this.export_to_doc(stringData);
          break;
        case 'pdf':
          this.export_to_pdf(stringData);
          break;
        case 'txt':
          this.export_to_txt(this.removeHTMLTags(stringData));
          break;
        case 'excel':
          this.export_excel(disposition.export_range, this.removeHTMLTags(stringData));
          break;
        default:
          break;
      }
    },
    export_to_txt(stringData) {
      const blob = new Blob([stringData], {
        type: 'text/plain;charset=utf-8',
      }); // 根据 blob生成 url链接
      const objectURL = URL.createObjectURL(blob); // 创建一个 a 标签Tag
      const aTag = document.createElement('a'); // 设置文件的下载地址
      aTag.href = objectURL; // 设置保存后的文件名称
      aTag.download = this.select_scene_desc + '.txt'; // 给 a 标签添加点击事件
      aTag.click(); // 释放一个之前已经存在的、通过调用 URL.createObjectURL() 创建的 URL 对象。 // 当你结束使用某个 URL 对象之后，应该通过调用这个方法来让浏览器知道不用在内存中继续保留对这个文件的引用了。
      URL.revokeObjectURL(objectURL);
    },
    async export_to_pdf(stringData) {
      // 按需异步加载 pdfMake
      const pdfMake = (await import('pdfmake')).default || await import('pdfmake');
      const docDefinition = {
        content: [stringData],
      };
      pdfMake.createPdf(docDefinition).download(this.select_scene_desc);
    },
    export_to_doc(stringData) {
      const blob = new Blob([stringData], {
        type: 'application/msword;charset=utf-8',
      }); // 创建BLOB对象
      saveAs(blob, this.select_scene_desc + '.doc'); // 保存为DOC文件
    },
    //导出为excel文件
    async export_excel(export_range, stringData) {
      // 按需异步加载 xlsx
      const { utils, writeFileXLSX } = await import('xlsx');

      let excel_arr = []
      switch (export_range) {
        case this.lang.workspace:
          excel_arr = [{
            user_name: this.user.userName,
            content: stringData,
            scene_name: this.select_scene_desc,
            create_time: new Date(new Date().getTime())
          }]
          break;
        default:
          excel_arr = JSON.parse(JSON.stringify(this.aiChatMessages));
          excel_arr.forEach((item) => {
            delete item.role;
            delete item.uid;
            delete item.AI;
            delete item.oldContent;
            delete item.isShowSynchronization;
            delete item.loading;
            delete item.filename;
            delete item.index;
            delete item.is_mind_map;
            delete item.graph;
            delete item.fileid;
          });
          break;
      }
      const ws = utils.json_to_sheet(excel_arr);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, 'Data');
      writeFileXLSX(wb, 'CocoroboAiChat.xlsx');
    },
    stop_voice:_.throttle(function (functionNames='') {
      let that = this;
      this.record_start = true;
      if (functionNames.includes('get_azure_speech')) {
        this.agentRecorder.stop(
            (blob) => {
              this.agentRecorder.close(); //释放录音资源，当然可以不释放，后面可以连续调用start；但不释放时系统或浏览器会一直提示在录音，最佳操作是录完就close掉
              this.agentRecorder = null;
              this.loadingInstance = Loading.service({
                fullscreen: true,
                text: this.lang.fxwj,
              });
              const file = new File([blob], new Date().getTime() + '.wav', {
                type: 'audio/wav',
              });
              this.upload_resource(file).then(res => {
                    this.sound_url = res
                    this.handlePdfProblem(`根据语音url,生成语音的评分<br/> <audio  controls
                  id='audio_${that.uid}'
                  style='width:250px;height:30px;margin-top:10px'
                  >
                    <source src=${res} type="audio/mpeg">
                  </audio>`, true);
                    this.$nextTick(() => {
                      // 以服务的方式调用的 Loading 需要异步关闭
                      this.loadingInstance.close();
                    });
                  }
              )
            },
            (msg) => {
              console.log('录音失败:' + msg);
              this.agentRecorder.close(); //可以通过stop方法的第3个参数来自动调用close
              this.agentRecorder = null;
            }
        );
      } else {
        //this.speechRecognizer.stopContinuousRecognitionAsync();
        this.speechRecognizer.sessionStopped();
      }
      that.sendMessage_flag = false;
    },2000),
    send_voice:_.throttle(function (functionNames='') {
      let that = this;
      that.text = "";
      if (functionNames.includes('get_azure_speech')) {
        this.agentRecorder = Recorder({
          //本配置参数请参考下面的文档，有详细介绍
          type: 'wav',
          sampleRate: 16000,
          bitRate: 16, //mp3格式，指定采样率hz、比特率kbps，其他参数使用默认配置；注意：是数字的参数必须提供数字，不要用字符串；需要使用的type类型，需提前把格式支持文件加载进来，比如使用wav格式需要提前加载wav.js编码引擎
          disableEnvInFix: false,
        });
        this.agentRecorder.open(
            () => {
              this.record_start = false;
              //打开麦克风授权获得相关资源
              //rec.start() 此处可以立即开始录音，但不建议这样编写，因为open是一个延迟漫长的操作，通过两次用户操作来分别调用open和start是推荐的最佳流程
              this.agentRecorder.start();
            },
            function (msg, isUserNotAllow) {
              //用户拒绝未授权或不支持
              console.log(
                  (isUserNotAllow ? 'UserNotAllow，' : '') + '无法录音:' + msg
              );
            }
        );
      } else {
        // this.speechRecognizer = SpeechSDK.SpeechRecognizer.FromConfig(
        //   this.speechConfig,
        //   this.autoDetectSourceLanguageConfig,
        //   this.audioConfig
        // );
        this.speechRecognizer  = SpeechSDK.ConversationTranscriber.FromConfig(this.speechConfig, this.autoDetectSourceLanguageConfig,this.audioConfig);
        this.speechRecognizer.sessionStarted = (s, e)=> {
          console.log("SessionStarted event");
          console.log("SessionId:" + e.sessionId);
          this.record_start = false;
        };
        this.speechRecognizer.sessionStopped = ()=> {
          console.log("SessionStopped event");
          this.speechRecognizer.stopTranscribingAsync();
          this.is_text = true;
        };
        this.speechRecognizer.canceled = (s, e)=> {
          console.log("Canceled event");
          console.log(e.errorDetails);
          this.speechRecognizer.stopTranscribingAsync();
        };
        this.speechRecognizer.transcribed = (s, e)=> {
          //console.log("TRANSCRIBED: Text=" + e.result.text + " Speaker ID=" + e.result.speakerId);
          if(e.result.text){
            this.text += e.result.text;
          }
        };

        // Start conversation transcription
        this.speechRecognizer.startTranscribingAsync(
            function () {

            },
            function (err) {
              console.trace("err - starting transcription: " + err);
            }
        );
        // this.speechRecognizer.recognized = (s, e) => {
        //   if (e.result.reason == SpeechSDK.ResultReason.RecognizedSpeech) {
        //       this.toprecognizing(e.result.text);
        //   }
        //   else if (e.result.reason == SpeechSDK.ResultReason.NoMatch) {
        //       console.log("NOMATCH: Speech could not be recognized.");
        //   }
        // };
        // this.speechRecognizer?.startContinuousRecognitionAsync(
        //   () => {
        //     this.record_start = false;
        //   },
        //   (err) => {
        //     console.log(err)
        //   }
        // );
      }
    },2000),

    stop_record_and_send: _.throttle(async function () {
      // 停止microsoft的实时语音转写
      // var live = true;
      if (this.inputModeTranscribedText) {
        if (this.speechRecognizer) {
          // 正确做法：调用 stopTranscribingAsync()，不要手动调用 sessionStopped()
          this.speechRecognizer.stopTranscribingAsync();
        }
      }
      this.record_start = true;
      // 停止波形
      this.stopWaveSurfer && this.stopWaveSurfer();

      // 停止录音，获取 wav blob，复用 send_voice 的流式上传逻辑
      if (!this.agentRecorder) {
        this.$message.error(this.lang.recordingnotstarted);
        return;
      }
      this.agentRecorder.stop(async (blob, duration) => {
        // 1. 先展示本地录音（可回放）
        const userAudioUrl = URL.createObjectURL(blob);
        if (this.aiChatMessages) {
          const msg = this.initUserAudioBubbleFields(userAudioUrl, Math.round(duration / 1000));
          this.aiChatMessages.push(msg);
        }
        this.loading = true;
        this.$message.success(this.lang.recordingend);
        console.log('[stop_voice] 录音停止，时长:', duration, 'ms, blob:', blob);

        // 读取 blob 为 arrayBuffer
        const buffer = await blob.arrayBuffer();
        // base64 转换
        function arrayBufferToBase64(buffer) {
          let binary = '';
          const bytes = new Uint8Array(buffer);
          const chunkSize = 0x8000;
          for (let i = 0; i < bytes.length; i += chunkSize) {
            binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize));
          }
          return window.btoa(binary);
        }
        const base64str = arrayBufferToBase64(buffer);
        console.log('[stop_voice] wav转base64完成, 长度:', base64str.length);
        
        // 组装参数
        const params = {
          id: this.agent_data.id,
          userId: this.$store.state.user.userId,
          model: this.agent_data.modelType,
          modalities: ["text", "audio"],
          audio: { voice: "alloy", format: "pcm16" },
          additional_messages: [
            {
              role: "user",
              content: [
                { type: "input_audio", input_audio: { data: base64str, format: "wav" } }
              ]
            }
          ],
          stream: true,
        };
        console.log('[stop_voice] 请求参数:', params);

        // debugger
        // 根据配置选择处理方式
        if (this.useCompleteAudioResponse) {
          // 使用完整音频响应处理
          await this.handleCompleteAudioResponse(params, blob, duration);
        } else {
          // 使用原有的流式处理
          await this.handleStreamingAudioResponse(params);
        }

        this.agentRecorder.close();
        this.agentRecorder = null;
        // 新增：停止录音后切换回文本输入框
        this.is_text = true;
      });
    }, 2000),

    // 干净版：仅负责开始录音（16k WAV），不掺杂其他逻辑/UI/上传
    async start_simple_recording() {
      // 若已存在录音实例则先关闭，避免占麦冲突
      try {
        if (this.agentRecorder) {
          this.agentRecorder.close();
          this.agentRecorder = null;
        }
      } catch (e) {
        console.warn('[start_simple_recording] 关闭旧实例失败:', e);
      }

      return await new Promise((resolve, reject) => {
        try {
          this.agentRecorder = Recorder({
            type: 'wav',
            sampleRate: 16000,
            bitRate: 16,
            disableEnvInFix: false,
            numberOfChannels: 1,
          });
          this.agentRecorder.open(
            () => {
              try {
                this.agentRecorder.start();
                resolve(true);
              } catch (err) {
                reject(err);
              }
            },
            (msg, isUserNotAllow) => {
              console.error('[start_simple_recording] 无法录音:', msg, 'notAllow=', isUserNotAllow);
              reject(new Error((isUserNotAllow ? 'UserNotAllow，' : '') + '无法录音: ' + msg));
            }
          );
        } catch (err) {
          reject(err);
        }
      });
    },

    // 干净版：仅负责停止录音并返回 Blob，不做上传/消息推送/调用LLM
    async stop_simple_recording() {
      return await new Promise((resolve, reject) => {
        if (!this.agentRecorder) {
          reject(new Error('未开始录音'));
          return;
        }
        try {
          this.agentRecorder.stop((blob, duration) => {
            try {
              const url = URL.createObjectURL(blob);
              // 释放录音资源
              try {
                this.agentRecorder.close();
              } catch (e) { console.error('[mixin] agentRecorder.close() 释放失败@stop_simple_recording: ', e); }
              this.agentRecorder = null;
              resolve({ blob, durationMs: duration, objectUrl: url });
            } catch (e) {
              reject(e);
            }
          }, (msg) => {
            console.error('[stop_simple_recording] 停止失败:', msg);
            try {
              this.agentRecorder.close();
            } catch (e) { console.error('[mixin] agentRecorder.close() 释放失败@stop_simple_recording(onError): ', e); }
            this.agentRecorder = null;
            reject(new Error('停止录音失败: ' + msg));
          });
        } catch (err) {
          try {
            this.agentRecorder.close();
          } catch (e) { console.error('[mixin] agentRecorder.close() 释放失败@stop_simple_recording(catch): ', e); }
          this.agentRecorder = null;
          reject(err);
        }
      });
    },
    start_recording: _.throttle(function () {
      this.is_text = false;
      // var live = true;
      // microsoft的实时语音转写, 实时转录开关需要打开
      // debugger
      if (this.inputModeTranscribedText) {
        this.initSpeechRecognizerTranscriber();
        // return;
      }

      // 只负责开始录音（wav）
      if (this.agentRecorder) {
        this.agentRecorder.close();
        this.agentRecorder = null;
      }
      // 录制 wav
      this.agentRecorder = Recorder({
        type: 'wav',
        sampleRate: 16000,
        bitRate: 16,
        disableEnvInFix: false,
      });
      this.agentRecorder.open(
        () => {
          this.record_start = false;
          this.agentRecorder.start();
          this.$message.success(this.lang.recordingbegin);
          this.$nextTick(() => {
            this.createWaveSurfer();
            if (this.record) this.record.startRecording();
          });
        },
        (msg, isUserNotAllow) => {
          this.$message.error(this.lang.recordingdenied);
          console.error('[send_voice] 录音权限被拒绝', msg, isUserNotAllow);
        }
      );
    }, 2000),
    toprecognizing(text) {
      if (text!=='.') {
        this.text += text;
      }
    },
    handle_model_list() {
      //仅在ai助手+使用，应用中心迁至对应的页面
      this.model_list_cn = [
        {
          name: this.lang.doubao,
          label: "doubao"
        },
        {
          name: "deepseek-chat",
          label: "deepseek-chat"
        },
        {
          name: "deepseek-reasoner",
          label: "deepseek-reasoner"
        },
        {
          name: "deepseek-r1:latest",
          label: "deepseek-r1:latest"
        },
        {
          name: "deepseek-r1:8b",
          label: "deepseek-r1:8b"
        },
        {
          name: this.lang.thousand_questions,
          label: "qwen-plus"
        },
        {
          name: this.lang.spectrum_wisdom,
          label: "glm-4-plus"
        },
        {
          name: this.lang.spectrum_wisdom_1,
          label: "glm-4-flash"
        },
        {
          name: "llama3.2",
          label: "llama3.2"
        },
      ]
      this.model_list_en = [
        {
          name: "gpt-4o-mini",
          label: "gpt-4o-mini"
        },
        {
          name: "gpt-4o-2024-11-20",
          label: "gpt-4o-2024-11-20"
        },
        {
          name: "gpt-4o-2024-08-06",
          label: "gpt-4o-2024-08-06"
        }
      ]
      this.model_list_open_cn=[
        {
          name: this.lang.doubao,
          label: "open-doubao"
        },
        {
          name: "DeepSeek",
          label: "open-deepseek-chat"
        },
        {
          name: this.lang.spectrum_wisdom,
          label: "open-glm-4"
        },
        {
          name: this.lang.spectrum_wisdom_1,
          label: "open-glm-4-flash"
        },
        {
          name: this.lang.thousand_questions,
          label: "open-qwen-plus"
        },
        {
          name: '备用模型',
          label: "open-gpt-4o-mini"
        }
      ]
      this.model_list_open_hk=[
        {
          name: this.lang.doubao,
          label: "open-doubao"
        },
        {
          name: "gpt-4o-mini",
          label: "open-gpt-4o-mini"
        },
        {
          name: "gpt-4o-2024-11-20",
          label: "open-gpt-4o-2024-11-20"
        },
        {
          name: "gpt-4o-2024-08-06",
          label: "open-gpt-4o-2024-08-06"
        },
        {
          name: "DeepSeek",
          label: "open-deepseek-chat"
        },
        {
          name: this.lang.spectrum_wisdom,
          label: "open-glm-4"
        },
        {
          name: this.lang.spectrum_wisdom_1,
          label: "open-glm-4-flash"
        },
        {
          name: this.lang.thousand_questions,
          label: "open-qwen-plus"
        }
      ]

      if (this.$isHk ||['45facc0a-1211-11ec-80ad-005056b86db5','26bfb1a2-001d-11ee-91d8-005056b86db5','0df61e4c-fe2d-11ef-b508-005056924926'].includes(this.user.organizeid)) {
        //hk域名、或组织为：cocorobo或cocorobo香港
        if (!this.$isHk && this.user.organizeid == '45facc0a-1211-11ec-80ad-005056b86db5' && this.select_scene_desc == this.lang.session_mode) {
          this.model_list = [
            {
              name: "gpt-4o-mini",
              label: "gpt-4o-mini"
            },
            {
              name: "o1-mini",
              label: "o1-mini"
            },
            {
              name: "o3-mini",
              label: "o3-mini"
            },
            {
              name: "gpt-4o-2024-11-20",
              label: "gpt-4o-2024-11-20"
            },
            {
              name: "gpt-4o-2024-08-06",
              label: "gpt-4o-2024-08-06"
            },
            {
              name: "deepseek-chat",
              label: "deepseek-chat"
            },
            {
              name: "deepseek-reasoner",
              label: "deepseek-reasoner"
            },
            {
              name: "deepseek-r1:latest",
              label: "deepseek-r1:latest"
            },
            {
              name: "deepseek-r1:8b",
              label: "deepseek-r1:8b"
            },
            // {
            //   name:"eduhk4o",
            //   label:"eduhk4o"
            // },
            {
              name: this.lang.thousand_questions,
              label: window.location.href.includes("ConferenceTrick") || window.location.href.includes("doc") ? "qwen-long" : "qwen-plus"
            },
            {
              name: this.lang.spectrum_wisdom,
              label: "glm-4-plus"
            },
            {
              name: this.lang.spectrum_wisdom_1,
              label: "glm-4-flash"
            },
            {
              name: "llama3.2",
              label: "llama3.2"
            },
          ]
        } else if (!this.$isHk && this.user.organizeid == '45facc0a-1211-11ec-80ad-005056b86db5' && this.select_scene_desc == this.lang.ai_agent || !this.$isHk && this.user.organizeid == '45facc0a-1211-11ec-80ad-005056b86db5' && this.select_scene_desc == this.lang.ai_agent_apark || !this.$isHk && this.user.organizeid == '45facc0a-1211-11ec-80ad-005056b86db5' && this.select_scene_desc == this.lang.muti_agent) {
          this.model_list = [{
              name: "gpt-4o-2024-08-06",
              label: "gpt-4o-2024-08-06"
            },
            {
              name: "gpt-4o-2024-11-20",
              label: "gpt-4o-2024-11-20"
            },
            {
              name: "gpt-4o-mini",
              label: "gpt-4o-mini"
            },
            {
              name: "deepseek-chat",
              label: "deepseek-chat"
            },
            {
              name: "deepseek-reasoner",
              label: "deepseek-reasoner"
            },
            {
              name: "deepseek-r1:latest",
              label: "deepseek-r1:latest"
            },
            {
              name: "deepseek-r1:8b",
              label: "deepseek-r1:8b"
            },
            {
              name: this.lang.thousand_questions,
              label: window.location.href.includes("ConferenceTrick") || window.location.href.includes("doc") ? "qwen-long" : "qwen-plus"
            },
            {
              name: this.lang.spectrum_wisdom,
              label: "glm-4-plus"
            },
            {
              name: this.lang.spectrum_wisdom_1,
              label: "glm-4-flash"
            },
            {
              name: this.lang.thousand_questions_1,
              label: "qwen-plus-own"
            },
            {
              name: "llama3.2",
              label: "llama3.2"
            },
            {
              name: this.lang.doubao,
              label: "doubao"
            },
          ]
        }
      } else {
        if (['28003c81-73ac-11ee-b98c-005056b86db5','700fe31d-86e2-11ef-9b30-005056b86db5','25cf5b8f-4ed6-11ed-8c78-005056b86db5'].includes(this.user.organizeid)) {
          //2024年未来教育基地教师培训（第二期）、华南师范大学、深圳教科院
          this.model_list = [
            {
              name: this.lang.doubao,
              label: "doubao"
            },
            {
              name: "默认模型",
              label: "gpt-4o-2024-11-20"
            },
            {
              name: "deepseek-chat",
              label: "deepseek-chat"
            },
            {
              name: "deepseek-reasoner",
              label: "deepseek-reasoner"
            },
            {
              name: "deepseek-r1:latest",
              label: "deepseek-r1:latest"
            },
            {
              name: "deepseek-r1:8b",
              label: "deepseek-r1:8b"
            },
            {
              name: this.lang.thousand_questions,
              label: window.location.href.includes("ConferenceTrick") ||
                window.location.href.includes("doc") ?
                "qwen-long" : "qwen-plus"
            },
            {
              name: this.lang.spectrum_wisdom,
              label: "glm-4-plus"
            },
            {
              name: this.lang.spectrum_wisdom_1,
              label: "glm-4-flash"
            },
            {
              name: "llama3.2",
              label: "llama3.2"
            },
          ]
        } else {
          this.model_list = [
            {
              name: this.lang.doubao,
              label: "doubao"
            },
            {
              name: "deepseek-chat",
              label: "deepseek-chat"
            },
            {
              name: "deepseek-reasoner",
              label: "deepseek-reasoner"
            },
            {
              name: "deepseek-r1:latest",
              label: "deepseek-r1:latest"
            },
            {
              name: "deepseek-r1:8b",
              label: "deepseek-r1:8b"
            },
            {
              name: this.lang.thousand_questions,
              label: window.location.href.includes("ConferenceTrick") ||
                window.location.href.includes("doc") ?
                "qwen-long" : "qwen-plus"
            },
            {
              name: this.lang.spectrum_wisdom,
              label: "glm-4-plus"
            },
            {
              name: this.lang.spectrum_wisdom_1,
              label: "glm-4-flash"
            },
            {
              name: "llama3.2",
              label: "llama3.2"
            },
          ]
        }
      }
      this.modelType = this.model_list[0].label
      this.model_name = this.model_list[0].name
    },
    getUrlParams(url) {
      const params = {};
      const urlObj = new URL(url);
      const queryString = urlObj.search.slice(1);
      const queryPairs = queryString.split('&');

      queryPairs.forEach(pair => {
        const [key, value] = pair.split('=');
        if (key) {
          params[decodeURIComponent(key)] = decodeURIComponent(value || '');
        }
      });

      return params;
    },
    upload_resource(file) {
      let that = this;
      return new Promise((resolve, reject) => {
        let fileType2 = file.name.split('.');
        let fileType = fileType2[fileType2.length - 1];
        const uniqueId = uuidv4();
        var credentials = {
          accessKeyId: 'AKIATLPEDU37QV5CHLMH',
          secretAccessKey: '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',
        }; //绉橀挜褰㈠紡鐨勭櫥褰曚笂浼�sendPdf
        window.AWS.config.update(credentials);
        window.AWS.config.region = 'cn-northwest-1'; //璁剧疆鍖哄煙
        var bucket = new window.AWS.S3({
          params: {
            Bucket: 'ccrb',
          },
        }); //閫夋嫨妗�
        var params = {
          Key: file.name.split('.')[0] + "-" + uniqueId + '.' + fileType,
          ContentType: file.type,
          Body: file,
          'Access-Control-Allow-Credentials': '*',
          ACL: 'public-read',
        };
        var options = {
          partSize: 2048 * 1024 * 1024,
          queueSize: 2,
          leavePartsOnError: true,
        };
        bucket
          .upload(params, options)
          .on('httpUploadProgress', (evt) => {
            if (evt.loaded / evt.total < 1) {
              that.send_button_display = true;
            }
          })
          .send((err, data) => {
            if (data) {
              resolve(data.Location)
            } else {
              console.log(err)
              that.$message.error(that.lang.cxsc);
              reject(false);
            }
          });
      })
    },
    wxShare(shareAllData) {
      wx.ready(function () {
        wx.onMenuShareAppMessage(shareAllData);
        wx.onMenuShareTimeline({
          title: shareAllData.title,
          desc: shareAllData.desc,
          link: shareAllData.link,
          imgUrl: shareAllData.imgUrl
        });
      });
    },
    wx_share(shareAllData) {
      // console.log(window.location.href.split("#")[0])
      // let urlStr = window.location.href.split("#")[0]
      this.$axios({
          method: 'post',
          data: {
            urlStr: shareAllData.link.split("#")[0].replaceAll('hk', 'cn')
          },
          url: this.GLOBAL.Base_Url + 'get_signature'
        }).then((response) => {
          // console.log(response);
          wx.config({
            debug: false, // 开启调试模式,
            appId: 'wx2d69589899b7ecd6', // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: response.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: response.data.noncestr, // 必填，生成签名的随机串
            signature: response.data.signature, // 必填，签名，见附录1
            jsApiList: [
              'onMenuShareTimeline', 'onMenuShareAppMessage', 'getLocation',
              'onMenuShareQQ', 'onMenuShareWeibo',
              'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'pauseVoice',
              'stopVoice', 'onVoicePlayEnd',
              'uploadVoice'
            ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          this.wxShare(shareAllData)
        })
        .catch(() => {
          console.log("接口请求失败！");
        });
    },
    removeHTMLTags(text) {
      if (text) {
        // return text.replace(/<[^>]+>/g, '\n');
        return text.replace(/<[^>]+>/g, '');
      }
    },
    createtime_add8(createtime) {
      // 获取当前浏览器的本地时间偏移量（分钟）
      var offsetMinutes = moment().utcOffset();
      // 转换为小时
      var offsetHours = offsetMinutes / 60;
      const date = moment.utc(createtime).utcOffset(offsetHours)
      return date.format("YYYY-MM-DD HH:mm:ss");
    },
    copyAiContent(data) {
      let datas = data.replace(/\\n/g, "");
      datas = this.removeHTMLTags(datas)
      let flag = this.copyText(datas);
      if (flag) {
        this.$message.success(this.lang.fzcg);
        const json_data = this.lang.copy_muti_agent;
        let arr = {
          action: json_data,
          content: datas
        }
        this.insert_operating_record(JSON.stringify(arr))
      } else {
        this.$message.error(this.lang.fz);
      }
    },
    copyText(text) {
      const textArea = document.createElement('textArea');
      textArea.value = text;
      textArea.style.width = 0;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999px';
      textArea.style.top = '10px';
      textArea.setAttribute('readonly', 'readonly');
      document.body.appendChild(textArea);
      textArea.select();
      var flag = null;
      try {
        flag = document.execCommand('copy');
      } catch {
        flag = false;
      }
      document.body.removeChild(textArea);
      return flag;
    },
    insertAtCursor(inputElement, textToInsert) {
      // 获取当前光标位置
  const startPos = inputElement.selectionStart;
  const endPos = inputElement.selectionEnd;
  
  // 获取当前输入框的值
  const currentValue = inputElement.value;
  
  // 在光标位置插入文本
  inputElement.value = currentValue.substring(0, startPos) + 
                      textToInsert + 
                      currentValue.substring(endPos, currentValue.length);
  
  // 重新设置光标位置（插入文本之后）
  const newCursorPos = startPos + textToInsert.length;
  inputElement.selectionStart = newCursorPos;
  inputElement.selectionEnd = newCursorPos;
  
  // 聚焦输入框
  inputElement.focus();
  return inputElement.value;
      // if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number') {
      //   // 对于支持selectionStart和selectionEnd属性的输入框
      //   const startPos = el.selectionStart;
      //   const endPos = el.selectionEnd;
      //   el.value = el.value.substring(0, startPos) +
      //     text +
      //     el.value.substring(endPos, el.value.length);
      //   el.selectionStart = el.selectionEnd = startPos + text.length;
      //   console.log(el.value)
      //   return el.value;
      // }
    },
    // [已废弃] handle_rag_input / handle_base_search_node 是老版知识库检索路径，
    // 已被 KnowledgeBaseRetrieval 组件（base_search_input）的 searchFolder32 流程替代，
    // 当前无活跃调用方。BaseSearchResult 组件仅用于渲染历史数据。
    // handle_rag_input() {
    //   this.handle_base_search_node(
    //     this.aiChatMessages.at(-1).subject,
    //     this.aiChatMessages.at(-1).key_word,
    //     this.aiChatMessages.at(-1).grade,
    //     this.aiChatMessages.at(-1).type
    //   );
    //   this.push_ai_content(this.lang.base_searching, this.lang.System_tip);
    // },
    async texttospeech(datas) {
      const that = this;

      // 使用 Web Audio API 替代 MSE，解决 iOS Safari 等移动端不支持 MSE 的问题
      // 参考: https://github.com/microsoft/cognitive-services-speech-sdk-js/issues/767

      var speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
        process.env.VUE_APP_AZURE_SPEECH_KEY, process.env.VUE_APP_AZURE_SPEECH_REGION
      );
      speechConfig.speechSynthesisVoiceName = 'en-US-AvaMultilingualNeural';
      // 使用 MP3 格式，兼容 Web Audio API 的 decodeAudioData
      speechConfig.speechSynthesisOutputFormat = SpeechSDK.SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3;

      // 不传入 audioConfig，这样 SDK 会返回 audioData 而不是直接播放
      this.synthesizer = new SpeechSDK.SpeechSynthesizer(speechConfig, null);

      const ssml = `
          <speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" xml:lang="en-US">
            <voice rate="+5%" name="en-US-AvaMultilingualNeural">${datas}</voice>
          </speak>`;

      this.synthesizer.speakSsmlAsync(ssml,
        result => {
          // 检查 synthesizer 是否已被停止（pausesynthesizer 调用后会设为 null）
          if (!that.synthesizer) {
            console.log('[mixin] TTS synthesizer was stopped, skipping playback');
            return;
          }
          if (result.reason === SpeechSDK.ResultReason.SynthesizingAudioCompleted) {
            console.log("Speech synthesized successfully.");
            // 使用 Web Audio API 播放音频
            that._playAudioWithWebAudioAPI(result.audioData);
          }
          if (that.synthesizer) {
            that.synthesizer.close();
            that.synthesizer = null;
          }
        },
        error => {
          console.error("TTS Error:", error);
          that.is_autoplay = false;
          if (that.synthesizer) {
            that.synthesizer.close();
            that.synthesizer = null;
          }
        }
      );
    },

    // 使用 Web Audio API 播放音频数据（兼容移动端）
    _playAudioWithWebAudioAPI(audioData) {
      const that = this;

      // 检查是否应该播放（如果不在自动播放状态，跳过）
      if (!this.is_autoplay) {
        console.log('[mixin] _playAudioWithWebAudioAPI skipped: is_autoplay is false');
        return;
      }

      try {
        // 创建或复用 AudioContext
        if (!this.audioContext) {
          this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
        }

        // 如果 AudioContext 被暂停（iOS 要求用户交互后才能播放），先恢复
        if (this.audioContext.state === 'suspended') {
          this.audioContext.resume();
        }

        console.log('playback started');

        // 解码音频数据
        this.audioContext.decodeAudioData(
          audioData.slice(0), // 复制 ArrayBuffer，避免被 detach
          buffer => {
            // 停止之前的播放
            if (that.currentBufferSource) {
              try {
                that.currentBufferSource.stop();
              } catch (e) { /* 忽略已停止的错误 */ }
            }

            // 创建新的 BufferSource
            that.currentBufferSource = that.audioContext.createBufferSource();
            that.currentBufferSource.buffer = buffer;
            that.currentBufferSource.connect(that.audioContext.destination);

            // 播放结束回调
            that.currentBufferSource.onended = () => {
              that.is_autoplay = false;
              that.currentBufferSource = null;
              console.log('playback finished');
            };

            // 开始播放
            that.currentBufferSource.start(0);
          },
          error => {
            console.error('Audio decode error:', error);
            that.is_autoplay = false;
          }
        );
      } catch (e) {
        console.error('Web Audio API error:', e);
        this.is_autoplay = false;
      }
    },
    //停止文字转语音
    pausesynthesizer() {
      // 设置标志位，防止异步回调继续播放
      this.is_autoplay = false;

      try {
        // 停止 Web Audio API 播放
        if (this.currentBufferSource) {
          this.currentBufferSource.stop();
          this.currentBufferSource = null;
        }
        // 停止旧版 MSE 播放器（保留兼容性）
        if (this.player) {
          this.player.pause();
          this.player.close();
          this.player = null;
        }
        if (this.synthesizer) {
          this.synthesizer.close();
          this.synthesizer = null;
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 初始化流式TTS所需资源（与 texttospeech 分离，避免结束时自动关闭/改写 is_autoplay）
    _initStreamingTtsIfNeeded() {
      if (this.ttsSynthesizer && this.ttsPlayer) {
        console.log('[mixin] TTS合成器已存在，跳过初始化');
        return;
      }
      console.log('[mixin] 开始初始化TTS合成器');
      
      // 检查环境变量
      const key = process.env.VUE_APP_AZURE_SPEECH_KEY;
      const region = process.env.VUE_APP_AZURE_SPEECH_REGION;
      console.log('[mixin] Azure Speech配置检查:');
      console.log('[mixin] - 密钥存在:', !!key);
      console.log('[mixin] - 区域存在:', !!region);
      console.log('[mixin] - 区域值:', region);
      
      if (!key || !region) {
        console.error('[mixin] Azure Speech环境变量未设置');
        return;
      }
      
      // 使用与 texttospeech 完全相同的配置
      this.ttsPlayer = new SpeechSDK.SpeakerAudioDestination();
      
      // 添加音频播放事件监听器
      this.ttsPlayer.onAudioStart = function () {
        console.log('[mixin] 流式TTS播放开始');
      };
      this.ttsPlayer.onAudioEnd = () => {
        console.log('[mixin] 流式TTS播放结束');
      };
      
      const audioConfig = SpeechSDK.AudioConfig.fromSpeakerOutput(this.ttsPlayer);
      const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(key, region);
      speechConfig.speechSynthesisVoiceName = 'en-US-AvaMultilingualNeural';
      // 设置移动端兼容的音频输出格式，解决 MSE 不支持 MP3 的问题
      speechConfig.speechSynthesisOutputFormat = SpeechSDK.SpeechSynthesisOutputFormat.Webm24Khz16BitMonoOpus;
      console.log('[mixin] 语音名称设置为:', speechConfig.speechSynthesisVoiceName);
      
      this.ttsSynthesizer = new SpeechSDK.SpeechSynthesizer(speechConfig, audioConfig);
      console.log('[mixin] TTS合成器初始化完成');
    },
    // 启动一段会话的流式TTS
    start_streaming_tts(index) {
      console.log('[mixin] start_streaming_tts 被调用，index:', index);
      this.play_sound_index = index;
      this.is_autoplay = true;
      this.isTtsStreaming = true;
      this.ttsQueue = [];
      this.ttsBusy = false;
      console.log('[mixin] 流式TTS状态初始化完成，ttsBusy:', this.ttsBusy);
      this._initStreamingTtsIfNeeded();
    },
    // 停止当前流式TTS（清空队列并关闭播放器/合成器）
    stop_streaming_tts() {
      this.isTtsStreaming = false;
      this.ttsQueue = [];
      this.ttsBusy = false;
      try {
        if (this.ttsPlayer) {
          this.ttsPlayer.pause();
          this.ttsPlayer.close();
          this.ttsPlayer = null;
        }
        if (this.ttsSynthesizer) {
          this.ttsSynthesizer.close();
          this.ttsSynthesizer = null;
        }
      } catch (e) {
        console.log(e)
      }
      // 不在这里改 is_autoplay，交给上层 stop_sound 控制
    },
    // 推入一段文本（可为片段），内部切句后排队播放
    push_streaming_tts_text(chunkText='') {
      console.log('[mixin] push_streaming_tts_text 被调用，chunkText:', chunkText);
      console.log('[mixin] isTtsStreaming:', this.isTtsStreaming);
      if (!this.isTtsStreaming || !chunkText) {
        console.log('[mixin] push_streaming_tts_text 提前返回');
        return;
      }
      // 去除HTML与多余换行并累计到缓冲区
      let text = this.removeHTMLTags(chunkText.replace(/\\n/g, '')) || '';
      console.log('[mixin] 处理后的文本:', text);
      if (!text) {
        console.log('[mixin] 文本为空，提前返回');
        return;
      }
      this.ttsBuffer += text;
      console.log('[mixin] 当前ttsBuffer:', this.ttsBuffer);
      
      // 从缓冲区切出完整句子（以句号/问号/感叹号/英文.等为结束）
      const complete = [];
      // 使用全局匹配提取已完成句子
      const re = /[^。！？!?.]+[。！？!?.]+/g;
      let match;
      while ((match = re.exec(this.ttsBuffer)) !== null) {
        complete.push(match[0].trim());
      }
      console.log('[mixin] 切出的完整句子:', complete);
      
      // 计算剩余未完成部分（最后一个匹配结束到末尾）
      const lastIdx = complete.length ? this.ttsBuffer.lastIndexOf(complete[complete.length - 1]) + complete[complete.length - 1].length : 0;
      this.ttsBuffer = this.ttsBuffer.slice(lastIdx);
      console.log('[mixin] 剩余缓冲区:', this.ttsBuffer);
      
      // 入队完整句子
      complete.forEach(s => { if (s) this.ttsQueue.push(s); });
      console.log('[mixin] 当前队列长度:', this.ttsQueue.length);
      this._drainTtsQueue();
    },
    // 在流结束时调用，强制将缓冲区剩余文本作为一句播放
    flush_streaming_tts_end() {
      if (!this.isTtsStreaming) return;
      const rest = (this.ttsBuffer || '').trim();
      this.ttsBuffer = '';
      if (rest) {
        this.ttsQueue.push(rest);
        this._drainTtsQueue();
      }
    },
    _drainTtsQueue() {
      console.log('[mixin] _drainTtsQueue 被调用');
      console.log('[mixin] isTtsStreaming:', this.isTtsStreaming);
      console.log('[mixin] ttsBusy:', this.ttsBusy);
      
      // 如果ttsBusy为true但队列不为空，可能是回调没有执行，强制重置
      if (this.ttsBusy && this.ttsQueue.length > 0) {
        console.log('[mixin] 检测到ttsBusy为true但队列不为空，强制重置ttsBusy');
        this.ttsBusy = false;
      }
      
      if (!this.isTtsStreaming || this.ttsBusy) {
        console.log('[mixin] _drainTtsQueue 提前返回');
        return;
      }
      const next = this.ttsQueue.shift();
      console.log('[mixin] 下一个要播放的文本:', next);
      if (!next) {
        console.log('[mixin] 队列为空，返回');
        return;
      }
      this.ttsBusy = true;
      console.log('[mixin] 开始TTS合成，文本:', next);
      
      // 以SSML合成该句 - 使用与 texttospeech 完全相同的配置
      const ssml = `
          <speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" xml:lang="en-US">
            <voice rate="+5%" name="en-US-AvaMultilingualNeural">${next}</voice>
          </speak>`;
      console.log('[mixin] SSML内容:', ssml);
      
      try {
        this._initStreamingTtsIfNeeded();
        console.log('[mixin] TTS合成器已初始化');
        console.log('[mixin] ttsSynthesizer存在:', !!this.ttsSynthesizer);
        
        // 添加超时机制，防止TTS合成卡住
        const timeoutId = setTimeout(() => {
          console.error('[mixin] TTS合成超时，强制重置ttsBusy');
          this.ttsBusy = false;
          if (this.isTtsStreaming) {
            this._drainTtsQueue();
          }
        }, 10000); // 10秒超时
        
        this.ttsSynthesizer.speakSsmlAsync(
          ssml,
          result => {
            console.log('[mixin] TTS合成成功');
            clearTimeout(timeoutId);
            if (result.reason === SpeechSDK.ResultReason.SynthesizingAudioCompleted) {
              console.log('[mixin] 流式TTS合成完成');
            }
            this.ttsBusy = false;
            if (this.isTtsStreaming) {
              this._drainTtsQueue();
            }
          },
          error => {
            console.error('[mixin] Streaming TTS error:', error);
            clearTimeout(timeoutId);
            this.ttsBusy = false;
            if (this.isTtsStreaming) {
              this._drainTtsQueue();
            }
          }
        );
        console.log('[mixin] TTS合成请求已发送');
      } catch (e) {
        console.error('[mixin] Streaming TTS synth error:', e);
        this.ttsBusy = false;
      }
    },
    play_sound(data, index) {
      this.play_sound_index = index;
      this.is_autoplay = true;
      try {
        if (typeof window !== 'undefined') {
          window.__currentDebugVM__ = this;
        }
      } catch (e) { console.warn('[mixin] 设置 __currentDebugVM__ 失败:', e); }
      let datas = data.replace(/\\n/g, '');
      datas = this.removeHTMLTags(datas);
      this.pausesynthesizer()
      this.texttospeech(
        datas
      );
    },
    stop_sound() {
      this.is_autoplay = false;
      this.pausesynthesizer();
      this.stop_streaming_tts();
    },
    form_card_confirm(item) {
      const id = this.current_node.id;
      const properties = item.properties;
      this.form_card_message = '';
      properties.fields.forEach((item2) => {
        this.form_card_message += item2.value + '：' + item2.inputValue + '；';
      });
      this.lf.graphModel.getNodeModelById(id).setProperties({
        form_card_data: this.form_card_data,
        fields: properties.fields,
        content: this.form_card_message,
      });
      this.lf.graphModel
        .getNodeModelById(id)
        .setProperties({
          is_run: false,
        });
      this.handle_next_node_new(this.next_node.id);
    },
    // [已废弃] BaseSearchResult 老版检索路径
    // comfirm_rag() {
    //   this.loadingInstance = Loading.service({
    //     fullscreen: true
    //   });
    //   let fileUrlList = [];
    //   this.rag_result.forEach((item) => {
    //     fileUrlList.push(
    //       'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn' + item
    //     );
    //   });
    //   let file_knowledge = [];
    //   this.upload_file_knowledge_common(fileUrlList).then((flie_id) => {
    //     this.$nextTick(() => {
    //       this.loadingInstance.close();
    //     });
    //     //上传openai文件库
    //     file_knowledge = flie_id;
    //     this.lf.graphModel
    //       .getNodeModelById(this.current_node.id)
    //       .setProperties({
    //         searchData: this.rag_result,
    //         file_knowledge: file_knowledge,
    //         is_run: false
    //       });
    //     this.handle_next_node_new(this.next_node.id);
    //   });
    // },
    handle_user_guidance_range(){
      if(this.user_guidance_range==='current_node'){
        this.is_user_guidance=false;
      }
    },
    /**
     * 工作流节点流转控制器 - 负责节点切换和流程控制
     *
     * 职责：
     * - 控制节点间的流转逻辑
     * - 管理计数器重置和状态清理
     * - 协调调用基础层和执行层方法
     * - 处理用户引导和交互模式
     *
     * 调用链：handle_next_node_new → handle_current_next_last → switch_crad_new
     *
     * @param {string} node_id - 要切换到的节点ID，默认为下一个节点ID
     */
    handle_next_node_new(node_id=this.next_node.id) {
      // 如果 node_id 无效或不存在，停止执行
      if (!node_id || !this.lf || !this.lf.getNodeDataById) {
        console.warn('[handle_next_node_new] 无效的 node_id 或 lf 未初始化，停止执行:', node_id);
        if (this.$message && this.$message.warning) {
          this.$message.warning(this.lang.workflowStopNoNextNode);
        }
        return;
      }

      // 检查节点是否存在
      const targetNode = this.lf.getNodeDataById(node_id);
      if (!targetNode) {
        console.warn('[handle_next_node_new] 节点不存在，停止执行:', node_id);
        if (this.$message && this.$message.warning) {
          this.$message.warning(this.lang.workflowStopNodeNotFound);
        }
        return;
      }

      // ✅ 统一保存点：在成功跳转到下一个节点之前保存状态
      // 只在切换节点时保存（有当前节点且不是同一个节点）
      // 注：saveChatState 是可选方法，由 archiveMixin 提供（仅 dialogMode 需要）
      if (this.current_node?.id && this.current_node.id !== node_id) {
        // 保存"即将执行"的节点 id，恢复时可直接从该节点继续
        this.saveChatState?.(node_id);
      }

      // 如果切换到不同的节点，重置计数器和执行次数
      if(this.current_node && this.current_node.id!==node_id){
        this.reply_round=0;
        this.execution_times=0
      }

      // 处理用户引导范围
      this.handle_user_guidance_range();

      // 设置新的当前节点及其上下文关系
      this.handle_current_next_last(targetNode);

      // 准备当前节点数组（用于后续处理）
      let current_node = [];
      current_node.push(this.current_node);

      // 检查当前节点是否为交互模式
      if (this.current_node.properties?.interaction_model) {
        this.interaction_model_flag = true;
      } else {
        this.interaction_model_flag = false;
      }

      // 触发聊天界面滚动
      this.prevChatResult += '滚动';

      // 执行节点逻辑（根据节点类型执行不同的处理逻辑）
      this.switch_crad_new(current_node);
    },
    /**
     * 工作流节点初始化分发器 — 只负责每种卡片的"初始渲染"，不负责后续交互
     *
     * 由 handle_next_node_new 调用，根据节点类型 push 对应的消息到 aiChatMessages，
     * 或直接发起 SSE（agent_card）。
     *
     * 注意：这里只是卡片生命周期的第一步。用户交互和完成跳转在其他地方：
     *   - agent_card   → connectSse (chatCoreMixin) 发起 SSE，onDone 里做节点跳转
     *   - form_card    → form_card_confirm (mixin.js) 处理提交
     *   - reply_card   → handleWorkflowMessage (chatCoreMixin) 处理用户回复
     *   - upload_file  → 组件内 emit 完成后调 handle_next_node_new
     *   - choice_question → 组件内处理答题确认
     *   - start_node / end_node → 自包含，直接跳转或重置
     *
     * @param {Array} current_node - 当前要执行的节点数组（实际永远只有 1 个元素）
     */
    async switch_crad_new(current_node) {
      // 获取当前节点内容
      let currentNodeContent = this.current_node.properties.content;

      // 初始化各种处理变量
      let dispo_desc = '';        // 智能体配置描述
      let data_card = '';         // 数据卡片内容
      let flie_know = [];         // 文件知识库
      let file_know_Text = '';    // 文件知识文本
      let uuid = uuidv4();        // 生成唯一ID
      const getGraphData = this.lf.getGraphData(); // 获取图数据

      // 遍历所有当前节点
      // 注意：虽然使用循环处理，但实际上 current_node 数组只会包含1个元素
      // 因为调用方 handle_next_node_new 中只 push 了 this.current_node 一个节点
      for (let i = 0; i < current_node.length; i++) {
        // 检查是否为交互模式
        if (current_node[i].properties?.interaction_model) {
          this.interaction_model_flag = true;
        } else {
          this.interaction_model_flag = false;
        }

        // 设置节点为运行状态
        this.lf.setProperties(current_node[i].id, {
          is_run: true,
        });

        // 根据节点类型执行不同的处理逻辑
        switch (current_node[i].type) {
          case 'form_card':
            // 表单卡片：初始化表单数据并显示表单界面
            this.form_card_data = [];
            current_node[i].properties.fields.forEach((item, fields_index) => {
              this.form_card_data.push({ ...item, input: '' });
              current_node[i].properties.fields[fields_index]['inputValue'] =
                '';
            });
            this.aiChatMessages.push({
              role: 'user',
              content: '',
              uid: uuidv4(),
              AI: 'AI',
              aiContent: 'form_card',
              oldContent: '',
              form_card: true, // 表单卡片标记：muti_agent_chat_new.vue 会据此渲染 <FormCard />
							filename:"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E9%BB%98%E8%AE%A4%E5%A4%B4%E5%83%8F31741424053754.svg",
              id: current_node[i].id,
              properties: JSON.parse(
                JSON.stringify(current_node[i].properties)
              ),
            });
            break;
          case 'mode_card':
            // 模式卡片：显示模式选择界面
            this.aiChatMessages.push({
              role: 'user',
              content: '',
              uid: uuidv4(),
              AI: 'AI',
              aiContent: 'mode_card',
              oldContent: '',
              generation_pattern: true, //模式选择卡片的样式
              id: current_node[i].id,
            });
            break;
          case 'UserTask':
          case 'agent_card':
            this.handle_incoming_node_mon();
            dispo_desc = this.handle_agent_disposition(current_node[i]);
            flie_know = this.handle_flie_know(current_node[i]);
            data_card = this.handle_data_card(current_node[i]);
						file_know_Text = this.handle_file_knowText(current_node[i]);

            // 检查是否为用户输入卡片
            if (this.handle_user_input_card(current_node[i])) {
              return;
            }

            // [已废弃] polygon 答题卡片 - UI入口已注释，不再创建新的 polygon 节点
            // var incomingNode = this.lf.getNodeIncomingNode(current_node[i].id);
            // var have_answer_card = incomingNode.some((node) => {
            //   return node.type === 'polygon';
            // });
            //
            // if (have_answer_card) {
            //   this.answer_card_flag = true;
            //   this.connectSse(
            //     current_node[i],
            //     `${dispo_desc}。${data_card}。${file_know_Text}。${this.user_input_arr}。请回复`,
            //     flie_know
            //   ).then(() => {
            //     this.handle_answer_card();
            //     this.dispo_conditional =
            //       current_node[i].properties.dispo_conditional;
            //   });
            //   return;
            // }

            // 构建消息内容
            var message = this.inputValue;
            dispo_desc == '' ? '' : (message += `${dispo_desc}。`);
            data_card == '' ? '' : (message += `${data_card}。`);
						file_know_Text == '' ? '' : (message += `${file_know_Text}。`);
            this.user_input_arr == ''
              ? ''
              : (message += `${this.user_input_arr}。`);

            // 发起 SSE 智能体对话 → chatCoreMixin.connectSse → sseTransport
            if (message != '') {
              this.connectSse(current_node[i], message, flie_know);
            } else {
              this.connectSse(current_node[i], this.lang.start_run_message, flie_know);
            }
            
            break;
          case 'upload_file':
            // 文件上传卡片：显示文件上传界面
            this.lastNodeId = current_node[i].id;
            this.aiChatMessages.push({
              role: 'user',
              content: '',
              uid: uuidv4(),
              AI: 'AI',
              aiContent: 'upload_file',
              upload_file: true, //表单卡片的样式
              oldContent: '',
              id: current_node[i].id,
              fileListNew: [],
              fileUrlList: [],
              upload_file_ids: [],
              isCanClick: true,
              isUpload: false,
              fileProgressPercent: 0,
              isFileProgress: false,
							filename:"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2Fupload_file_icon1740724443544.svg",
            });
            await true;
            break;
          case 'pdf_to_md':
            this.lastNodeId = current_node[i].id;
            this.aiChatMessages.push({
              role: 'user',
              content: '',
              uid: uuidv4(),
              AI: 'AI',
              aiContent: 'pdf_to_md',
              pdf_to_md: true, //表单卡片的样式
              oldContent: '',
              id: current_node[i].id,
              fileListNew: [],
              fileUrlList: [],
              upload_file_ids: [],
              isCanClick: true,
              isUpload: false,
              lastNodeContent: currentNodeContent,
              fileProgressPercent: 0,
              isFileProgress: false,
							filename:"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2Fpdt_to_md_icon1740723792175.svg"
            });
            await true;
            break;
          case 'create_ppt':
            this.loading=true;
            this.aiChatMessages.push({
              role: 'user',
              content: '',
              uid: uuidv4(),
              AI: 'AI',
              aiContent: '</br>',
              oldContent: '',
              create_ppt: true, //视频检索
							filename:require("@/assets/img/appCenter/generate_ppt_icon.svg"),
              id: current_node[i].id,
              properties: JSON.parse(
                JSON.stringify(current_node[i].properties)
              ),
            });
            this.prevChatResult = this.prevChatResult + '滚动';
            break;
          case 'boss_card':
            if (['UserTask', 'agent_card'].includes(this.last_node.type)) {
              this.handle_boss_card_new(this.sse_result, current_node[i].id);
            } else if (this.last_node.type == 'form_card') {
              this.handle_boss_card_new(
                '信息：' + this.form_card_message,
                current_node[i].id
              );
            } else if (this.last_node.type == 'reply_card') {
              this.handle_boss_card_new(
                this.lf.getProperties(this.last_node.id).content,
                current_node[i].id
              );
            } else if (this.inputValue != '') {
              this.handle_boss_card_new(this.inputValue, current_node[i].id);
            } else {
              this.$message.info(this.lang.srnr);
            }
            break;
          case 'conditions_card':
            if (['UserTask', 'agent_card'].includes(this.last_node.type)) {
              this.handle_conditions_card(this.sse_result, current_node[i].id);
            } else if (this.last_node.type == 'form_card') {
              this.handle_conditions_card(
                '信息：' + this.form_card_message,
                current_node[i].id
              );
            } else if (this.last_node.type == 'reply_card') {
              this.handle_conditions_card(
                this.lf.getProperties(this.last_node.id).content,
                current_node[i].id
              );
            } else if (this.inputValue != '') {
              this.handle_conditions_card(this.inputValue, current_node[i].id);
            } else {
              this.$message.info(this.lang.srnr);
            }
            break;
          case 'echart_card':
            this.aiChatMessages.push({
              role: 'user',
              content: this.lang.echart_card,
              uid: uuid,
              AI: 'AI',
              aiContent: this.sse_result,
              oldContent: '',
              isShowSynchronization: false,
              filename: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2Fchart_rendering_icon1740725256820.svg',
              fileid: '',
              echart_card: true,
              echart_text: '',
              echart_text2: '',
            });
            // this.ai_content = this.sse_result
            this.$nextTick(() => {
              this.handle_echart_code(uuid, this.ai_content);
            });
            this.handle_next_node_new(this.next_node.id);
            await true;
            break;
          case 'reply_card':
            // 回复卡片：等待用户输入回复
            this.handle_current_next_last(current_node[i]);
            this.reply_card_flag = true;
            // 兼容新旧两种方式访问 bottomInput
            if (this.$refs.chatInputArea) {
              this.$refs.chatInputArea.focusInput();
            } else if (this.$refs.bottomInput) {
              this.$refs.bottomInput.focus();
            }
            var reply_card_content = this.lf.getNodeDataById(current_node[i].id)
              .properties.prompt;
            this.$message.info(this.lang.srnr);
            this.push_ai_content(
              reply_card_content ? reply_card_content : this.lang.Please_answer,
              this.lang.System_tip,"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2Fanswer_card_icon1740725778497.svg"
            );
            break;
          case 'end_node':
            // 结束节点：显示结束消息并重置数据
            this.aiChatMessages.push({
              role: 'user',
              content: '',
              uid: uuidv4(),
              AI: 'AI',
              aiContent: this.lang.end_conversation,
              oldContent: '',
              isShowSynchronization: false,
              filename: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2Fstart1740725295994.svg',
              is_mind_map: false,
              fileid: '',
              index: this.aiChatMessages.length,
              type: 'prologue',
            });
            this.prevChatResult += '滚动';
            // 终点：初始化数据
            this.handle_init_data("end");
            await true;
            break;
          case 'rect':
          case 'start_node':
            // 开始节点：重置所有节点状态并显示开始消息
            getGraphData.nodes.forEach((item) => {
              this.lf.graphModel.getNodeModelById(item.id).setProperties({
                content: '',
                is_run: false,
              });
            });
            // 先设置当前节点和下一个节点
            this.handle_current_next_last(this.lf.getNodeDataById('node_id_1'));
            
            var startNodeContent = this.getStartNodeContent();
            this.aiChatMessages.push({
              role: 'user',
              content: '',
              uid: uuidv4(),
              AI: 'AI',
              aiContent: startNodeContent,
              oldContent: '',
              isShowSynchronization: false,
              filename: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2Fstart1740724797597.svg',
              is_mind_map: false,
              fileid: '',
            });
            this.prevChatResult += '滚动';
            this.handle_next_node_new(this.next_node.id);
            break;
          case 'base_search':
            this.aiChatMessages.push({
              role: 'user',
              content: '',
              uid: uuidv4(),
              AI: 'AI',
              aiContent: 'nihao',
              oldContent: '',
              isShowSynchronization: false,
              filename: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2Fknowledge_base_retrieval_icon1740724683364.svg',
              is_mind_map: false,
              fileid: '',
              base_search_input: true,
              prompt:current_node[i].properties.language_plan,
              maximumReturned: current_node[i].properties.maximumReturned,//返回数量
              returnResult: current_node[i].properties.returnResult,//切片 或者 文档
              retrievalStrategy: current_node[i].properties.retrievalStrategy,
              fileList:current_node[i].properties.fileList,//文件列表
              folderList:current_node[i].properties.folderList,//文件夹列表
              grade: current_node[i].properties.grade,
              subject: current_node[i].properties.subject,
              key_word: current_node[i].properties.key_word,
              is_modify: current_node[i].properties.is_modify,
              type: current_node[i].properties.type,
							source:current_node[i].properties.source,//检索方式  用户输入   节点数据
							nodeSource:current_node[i].properties.nodeSource,//前置节点ID
							allowLimitedFolder:current_node[i].properties.allowLimitedFolder,//允许筛选文件夹
							variable_name:current_node[i].properties.variable_name,
							inputValue:"",
							selectFolderOptions:[...current_node[i].properties.folderList,...current_node[i].properties.fileList],
							selectFolder:[...current_node[i].properties.folderList,...current_node[i].properties.fileList].map((item,index)=>index),
							resultList:[],
							checkList:[],
							showResult:false,
							empty:false,
							chooseList:[],
							chooseAll:false,
            });

            this.prevChatResult += '滚动';
            break;
          case 'deploy_card':
            this.handle_next_node_new(this.next_node.id);
            break;
          case 'scoring_card':
            try {
              this.scoring_number =
                this.scoring_number + Number(this.ai_content);
            } catch {
              this.scoring_number = 0;
            }
            this.lf.graphModel
              .getNodeModelById(current_node[i].id)
              .setProperties({
                content: this.scoring_number,
              });
            this.handle_next_node_new(this.next_node.id);
            break;
          case 'user_input':
            // 用户输入节点：等待用户输入并暂停流程
            this.user_input_wait = true;
            // 兼容新旧两种方式访问 bottomInput
            if (this.$refs.chatInputArea) {
              this.$refs.chatInputArea.focusInput();
            } else if (this.$refs.bottomInput) {
              this.$refs.bottomInput.focus();
            }
            this.user_input_arr =
              this.current_node.properties.input_value + '。';
            this.answer_arr.push({
              id: this.current_node.id,
              answer: this.current_node.properties.input_value,
            });
            this.aiChatMessages.push({
              role: 'user',
              content: '',
              uid: this.uid_new,
              AI: 'AI',
              aiContent: this.current_node.properties.input_value,
              oldContent: '',
              isShowSynchronization: false,
              filename: 'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2Fwait_for_input_icon1740725338807.svg',
              is_mind_map: false,
              user_input: true,
              fileid: '',
            });
            // this.nodes_index = index;
            // 兼容新旧两种方式访问 bottomInput
            if (this.$refs.chatInputArea) {
              this.$refs.chatInputArea.focusInput();
            } else if (this.$refs.bottomInput) {
              this.$refs.bottomInput.focus();
            }
            this.insertChat(
              this.current_node.properties.input_value,
              this.inputValue,
              'chat',
              this.current_node.properties.input_value,
              '',
              ''
            );
            this.prevChatResult = this.prevChatResult + '滚动';
            this.handle_current_next_last(this.next_node);
            break;
          case 'ocr_card':
            this.aiChatMessages.push({
              role: 'user',
              content: '',
              uid: uuidv4(),
              AI: 'AI',
              aiContent: 'ocr_card',
              ocr_card: true, //样式
              oldContent: '',
              id: current_node[i].id,
              fileListNew: [],
              fileUrlList: [],
              upload_file_ids: [],
              isCanClick: true,
              isUpload: false,
              fileProgressPercent: 0,
              isFileProgress: false,
							filename:"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2Forc_ecognition_icon1740723628798.svg"
            });
            await true;
            break;
          case 'choice_question':
            // 选择题卡片逻辑：当首次进入且有 dispo_desc 时，先根据 dispo_desc 生成题库；否则直接渲染现有题库的下一题
            // 1) 计算当前节点（UserTask/agent_card）的处置描述（带占位符的模板已被替换成具体内容）
            dispo_desc = this.handle_agent_disposition(current_node[i]);
            if (dispo_desc && this.choice_question_index == 0) {
              // 首题需要向后端请求生成题库，期间展示 loading
              this.loadingInstance = Loading.service({
                fullscreen: true,
                text: this.lang.questioning,
              });
              // 构造题库生成请求：把处置文本拼到提示词中
              var config = {
                method: 'post',
                url: this.GLOBAL.Base_Url + 'ai_agent_park_chat',
                headers: {
                  'Content-Type': 'application/json',
                  hwMac: store.state.user.organizeid,
                },
                data: {
                  userId: store.state.user.userId,
                  message:
                    this.lang.no_search_file +
                    this.lang.questioning_desc +
                    dispo_desc,
                  file_ids: [],
                  session_name: uuidv4(),
                  model: 'gpt-4o-2024-11-20',
                  assistant_id: 'asst_W9XPXoUcLH1yGeiDLCLpC800',
                  temperature: 0.1,
                },
              };
              // 调用接口拿到题库并写回节点属性，随后在聊天列表插入“选择题卡片”用于前端渲染
              this.$axios(config).then((res) => {
                let question_bank = [];
                try {
                  // 常规返回：直接解析 JSON
                  question_bank = JSON.parse(res.data.FunctionResponse.message);
                } catch (error) {
                  // 兼容返回：内容被 ```json 包裹时做提取与清洗
                  const message = JSON.parse(res.data.FunctionResponse.message);
                  let message2 = message.split('```json')[1].split('```')[0];
                  question_bank = message2.replaceAll('\n', '');
                }
                // 将题库写入当前节点，供后续题目渲染与判分
                this.lf.graphModel
                  .getNodeModelById(current_node[i].id)
                  .setProperties({
                    question_bank,
                  });
                // 在聊天区追加“选择题卡片”消息：前端据此展示题干/选项
                this.aiChatMessages.push({
                  role: 'user',
                  content: '',
                  uid: uuidv4(),
                  AI: 'AI',
                  aiContent: 'choice_question',
                  choice_question: true, // 样式标记
                  oldContent: '',
                  id: current_node[i].id,
                  choice_question_index: this.choice_question_index, // 当前题号（从 0 开始）
                  question_bank: question_bank,
                  filename:"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2Fsingle_choice_question_icon1740724476508.svg",
                  answers: [], // v-model 绑定收集用户作答
                });
                this.prevChatResult = this.prevChatResult + '滚动';
                // 刷新 current/next/last 引用，保证后续跳转正确
                this.handle_current_next_last(
                  this.lf.getNodeDataById(current_node[i].id)
                );
                // 结束 loading
                this.$nextTick(() => {
                  this.loadingInstance.close();
                });
              });
            } else {
              // 非首题或题库已存在：直接渲染题库的下一题
              if (this.current_node.properties.question_bank.length == 0) {
                this.$message.error(this.lang.no_question);
                return;
              }
              // 继续推入“选择题卡片”消息 —— 使用已存在的 question_bank 和当前题号
              this.aiChatMessages.push({
                role: 'user',
                content: '',
                uid: uuidv4(),
                AI: 'AI',
                aiContent: 'choice_question',
                choice_question: true, // 样式标记
                oldContent: '',
                id: current_node[i].id,
                choice_question_index: this.choice_question_index,
                question_bank: this.current_node.properties.question_bank,
                filename:"https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/default%2Fsingle_choice_question_icon1740724476508.svg",
                answers: [],
              });
              this.prevChatResult = this.prevChatResult + '滚动';
            }
            break;
          case 'video_search':  
            this.loading=true;
            this.aiChatMessages.push({
              role: 'user',
              content: '',
              uid: uuidv4(),
              AI: 'AI',
              aiContent: '</br>',
              oldContent: '',
              video_search: true, //视频检索
							filename:require("@/assets/img/appCenter/video_search_card.svg"),
              id: current_node[i].id,
              properties: JSON.parse(
                JSON.stringify(current_node[i].properties)
              ),
            });
            this.prevChatResult = this.prevChatResult + '滚动';
            break;
          case 'user_guidance':
            //console.log(this.current_node)
            this.user_guidance_range=this.current_node.properties.range
            this.user_guidance_data=this.current_node;
            this.is_user_guidance=true;
            this.handle_next_node_new(this.next_node.id);
            break;
          default:
            this.handle_next_node_new(this.next_node.id);
            break;
        }

        // 如果是最后一个节点且为交互模式，清空输入值
        if (
          i == current_node.length - 1 &&
          // current_node[i].type != 'reply_card' &&
          this.interaction_model_flag
        ) {
          this.inputValue = '';
        }
      }
    },
    // comfirm_choice_question(item) {
    //   if (JSON.stringify(this.current_node.properties.question_bank[this.choice_question_index].answers) === JSON.stringify(item.answers)) {
    //     this.aiChatMessages.push({
    //       role: 'user',
    //       content: '',
    //       uid: uuidv4(),
    //       AI: 'AI',
    //       aiContent: this.lang.correct + "." + item.question_bank[this.choice_question_index].analyze,
    //       oldContent: '',
    //       id: this.current_node.id
    //     });
    //   } else {
    //     this.aiChatMessages.push({
    //       role: 'user',
    //       content: '',
    //       uid: uuidv4(),
    //       AI: 'AI',
    //       aiContent: this.lang.mistake + "." + item.question_bank[this.choice_question_index].analyze,
    //       oldContent: '',
    //       id: this.current_node.id
    //     });
    //   }
    //   this.prevChatResult = this.prevChatResult + '滚动';
    //   this.choice_question_index++;
    //   if (this.choice_question_index == this.current_node.properties.question_bank.length) {
    //     this.lf.graphModel
    //       .getNodeModelById(this.current_node.id)
    //       .setProperties({
    //         is_run: false,
    //       });
    //     this.choice_question_index = 0;
    //     this.handle_next_node_new(this.next_node.id);
    //   } else {
    //     this.handle_next_node_new(this.current_node.id);
    //   }
    // },
    // [已废弃] 见上方 handle_rag_input 注释
    // handle_base_search_node(subject, key_word, grade, type) {
    //   this.$axios
    //     .get(
    //       `https://pbl.cocorobo.cn/api/pbl/findMatchingContentsPage3?type=${subject}&string=${key_word}&grade=${grade}&filetype=${type}&page=1`
    //     )
    //     .then((res) => {
    //       //检索数据
    //       this.rag_result = [];
    //       res.data.forEach((item) => {
    //         this.rag_result.push(item.file_url);
    //       });
    //       this.all_rag_result = this.rag_result;
    //       this.aiChatMessages.push({
    //         role: 'user',
    //         content: '',
    //         uid: uuidv4(),
    //         AI: 'AI',
    //         aiContent: this.lang.base_search,
    //         oldContent: '',
    //         isShowSynchronization: false,
    //         filename: '',
    //         is_mind_map: false,
    //         fileid: '',
    //         base_search_flag: true,
    //         base_search_result: res.data,
    //       });
    //       this.prevChatResult = this.prevChatResult + '滚动';
    //       this.insertChat(
    //         JSON.stringify(this.aiChatMessages.at(-1)),
    //         '',
    //         'chat',
    //         '',
    //         '',
    //         ''
    //       );
    //     });
    // },
    async upload_file_knowledge_common(fileUrlList) {
      return await new Promise((resolve) => {
        const lf = this.lf || window.lf;
        const data = lf.getGraphData();
        let agentTypes = []
        data.nodes.forEach((data_item) => {
          if (["UserTask", "agent_card"].includes(data_item.type)) {
            if (data_item.properties.item?.modelType) {
              agentTypes.push(data_item.properties.item.modelType)
            }
          }}
        )
        //console.log(agentTypes)
        //let ids = [];
        const config = {
          method: 'put',
          url: this.new_url + '/api/agentchats/upload_mutiagent_file',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            url_list: fileUrlList,
            agentTypes: agentTypes // workflow 需要存在 agent node
          },
        };
        this.$axios(config)
          .then((response) => {
            let result = response.data;
            resolve(result);
            // let result = JSON.parse(response.data.FunctionResponse.result);
            // result.forEach((item) => {
            //   ids.push(item.id);
            // });
            // resolve(ids);
          })
          .catch(function (error) {
            console.log(error);
          });
      });
    },
    // [已废弃] BaseSearchResult 老版检索路径
    // handleCheckedRagChange(val) {
    //   this.rag_result = val ? this.all_rag_result : [];
    // },
    /**
     * 根据节点的处置模板（dispo_desc）与映射列表（dispo_arr）生成最终描述：
     * - dispo_desc 是字符串模板，包含形如 [占位说明] 的占位符
     * - dispo_arr 中记录了可引用节点（含 id/desc/type 等），用于获取对应节点的 properties.content
     * - 遍历 dispo_arr，将模板中的占位符替换为引用节点的内容；若未配置 dispo_desc 则返回空串
     */
    handle_agent_disposition(item) {
      // 读取当前节点的处置模板
      let dispo_desc = item.properties.dispo_desc;
      if (item.properties.dispo_desc) {
        // 遍历可引用节点映射，做占位符替换
        item.properties.dispo_arr.forEach((item_dispo_arr) => {
          // 节点存在时才尝试替换
          if (this.lf.getNodeDataById(item_dispo_arr.id)) {
            // 取该引用节点在运行期写入的最终内容
            let content = this.lf.getNodeDataById(item_dispo_arr.id).properties
              .content;
            // 将模板中的 [desc] 替换为对应节点内容
            dispo_desc = dispo_desc.replaceAll(
              `[${item_dispo_arr.desc}]`,
              `${content}`
            );
          }
        });
        // 返回替换后的处置描述
        return dispo_desc;
      } else {
        // 若未配置模板，返回空串
        return '';
      }
    },
    /**
     * 根据处置模板配置（dispo_arr）收集上游节点产出的知识库文件：
     * - 查找类型为 upload_file/base_search 的引用节点
     * - 读取其存储的文件 ID / 文档 ID，转换为当前请求需要的 file_ids
     * - 返回数组形式，供 connectSse 传给后端继续检索
     */
    handle_flie_know(item) {
      let file_knowledge = {};
      let file_id = ''
      if (item.properties.dispo_desc) {
        item.properties.dispo_arr.forEach((item_dispo_arr) => {
          if (

            item_dispo_arr.type === 'upload_file'
          ) {
            file_knowledge = this.lf.getNodeDataById(item_dispo_arr.id)
              .properties.file_knowledge;
            if(item.properties.item.modelType.includes('open')){
              if(file_knowledge?.openFileIdList?.length) file_id=file_knowledge.openFileIdList[0].id
            }else{
              if(item.properties.item.modelType.includes('gpt')){
                if(file_knowledge?.gptFileIdList?.length) file_id=file_knowledge.gptFileIdList[0].id
              }else{
                if(file_knowledge?.langchainFileIdList?.length) file_id=file_knowledge.langchainFileIdList[0].id
              }
            }
          }else if(item_dispo_arr.type === 'base_search'){
						let documentIdList = this.lf.getNodeDataById(item_dispo_arr.id)
						.properties.documentId;
						let type = this.lf.getNodeDataById(item_dispo_arr.id)
						.properties.type;

						if(type == 0 && documentIdList.length >0){
							file_id = documentIdList.join(',')
						}
					}
        });
      }
      return file_id?Array.isArray(file_id)?file_id:[file_id]:[];
    },
		handle_file_knowText(item){
      let text = ''
      if (item.properties.dispo_desc) {
        item.properties.dispo_arr.forEach((item_dispo_arr) => {
          if(item_dispo_arr.type === 'base_search'){
						let slice_dataList = this.lf.getNodeDataById(item_dispo_arr.id)
						.properties.slice_data;
						let type = this.lf.getNodeDataById(item_dispo_arr.id)
						.properties.type;
						if(type == 1 && slice_dataList.length >0){
							text = slice_dataList.join(',')
						}
					}
        });
      }
      return text;
		},
    /**
     * 处理当前节点的入边节点
     * 检查入边节点中是否有用户引导等特殊节点，并设置相应的状态
     */
    handle_incoming_node(){
      // 获取当前节点的所有入边节点（上一级节点）
      const IncomingNode =_.cloneDeep(this.lf.graphModel.getNodeIncomingNode(
        this.current_node.id
      ));

      // 遍历所有入边节点，处理特殊节点类型
      for (let index_user_input in IncomingNode) {
        const node_date= IncomingNode[index_user_input];
        switch (node_date.type) {
          case 'user_guidance':
            // 处理用户引导节点
            this.user_guidance_range=this.lf.getNodeDataById(node_date.id).properties.range //一定要这样写不然会触发bug
            this.user_guidance_data=this.lf.getNodeDataById(node_date.id)
            this.is_user_guidance=true;
            break;
          default:
            break;
        }
      }
    },
    /**
     * 遍历当前节点的所有入边节点，并针对标记为监控节点（is_mon_agent）的上游节点
     * 读取其触发条件（回复轮次、定时、语义判断等），在满足条件时更新
     * is_mon_agent / mon_agent_update，用于驱动自动执行。
     * 该方法与变量占位符替换无关，仅负责监控节点的触发逻辑。
     */
    handle_incoming_node_mon(){
      const IncomingNode =_.cloneDeep(this.lf.graphModel.getNodeIncomingNode(
        //获取节点所有上一级节点
        this.current_node.id
      ));
      for (let index_user_input in IncomingNode) {
        const node_date= IncomingNode[index_user_input];
        const node_date_new = this.lf.getNodeDataById(node_date.id);
        switch (node_date.type) {
          case 'UserTask':
            if(node_date_new.properties.is_mon_agent){
              this.mon_agent_properties=node_date_new.properties;
              for(let condition in node_date_new.properties.trigger_condition){
                switch (node_date_new.properties.trigger_condition[condition].direction_value) {
                  case '回复轮次':
                    this.reply_round++;
                    if(this.reply_round===node_date_new.properties.trigger_condition[condition].option_value){
                      this.is_mon_agent=true;
                      this.mon_agent_update++;
                    }
                  break;
                  case '回复时间':
                    this.startTimer();
                    break;
                  case '语义判断':
                    switch (node_date_new.properties.trigger_condition[condition].logical_option_value) {
                      case '仅执行首次':
                        if(this.execution_times===0){
                          this.semantic_judgment(node_date_new.properties.trigger_condition[condition].option_value);
                          this.execution_times++
                        }
                        break;
                      case '执行多次':
                        this.semantic_judgment(node_date_new.properties.trigger_condition[condition].option_value)
                        break;
                      default:
                        break;
                    }
                    break;
                  default:
                    break;
                }
              }
            }
            break;
          default:
            break;
        }
      }
    },
    semantic_judgment(judgmentConditionText){
      const messages= [
        {
          role: 'system',
          content: `你是一个语言专家，请判断用户的问题是否符合以下语义判断：\n${judgmentConditionText}\n输出要求：\n1. 如果符合，输出"1"\n2. 如果不符合或者无法判断，输出"0"\n3. 不要输出其他内容`
        },
        {
          role: 'user',
          content: '用户的问题：' + this.inputValue
        }
      ]
      this.chat_no_stream(messages).then(res=>{
        if(res==1){
          this.is_mon_agent=true;
          this.mon_agent_update++;
        }
      })
    },
    updateTimer() {
      this.timer = setInterval(() => {
        if (this.isRunning) {
          this.seconds++;
        }
      }, 1000);
    },
    startTimer() {
      if (!this.isRunning) {
        this.seconds=0;
        this.isRunning = true;
        this.updateTimer();
      }
    },
    stopTimer() {
      this.seconds=0;
      this.isRunning = false;
      clearInterval(this.timer);
      this.timer = null;
    },
    handle_data_card(item) {
      const IncomingNode = this.lf.graphModel.getNodeIncomingNode(
        //获取节点所有上一级节点
        item.id
      );
      let data_card = '';
      for (let index_user_input in IncomingNode) {
        if (IncomingNode[index_user_input].type == 'data_card') {
          // 数据卡片
          console.log(IncomingNode[index_user_input].properties)
          data_card =
            IncomingNode[index_user_input].properties.input_value;
        }
      }
      return data_card;
    },
    handle_user_input_card(item) {
      if (this.user_input_wait === true) return false;
      let that = this;
      const IncomingNode = this.lf.graphModel.getNodeIncomingNode(
        //获取节点所有上一级节点
        item.id
      );
      for (let index_user_input in IncomingNode) {
        //处理用户输入卡片
        if (IncomingNode[index_user_input].type == 'user_input') {
          // 停住，让用户输入
          this.user_input_wait = true;
          // 兼容新旧两种方式访问 bottomInput
          if (this.$refs.chatInputArea) {
            this.$refs.chatInputArea.focusInput();
          } else if (this.$refs.bottomInput && this.$refs.bottomInput.$refs && this.$refs.bottomInput.$refs.input) {
            this.$refs.bottomInput.$refs.input.focus();
          }
          this.user_input_arr =
            IncomingNode[index_user_input].properties.input_value + '。';
          this.answer_arr.push({
            id: IncomingNode[index_user_input].id,
            answer: IncomingNode[index_user_input].properties.input_value,
          });
          this.aiChatMessages.push({
            role: 'user',
            content: '',
            uid: that.uid_new,
            AI: 'AI',
            aiContent: IncomingNode[index_user_input].properties.input_value,
            oldContent: '',
            isShowSynchronization: false,
            filename: item.properties.headUrl,
            is_mind_map: false,
            user_input: true,
            fileid: item.properties.assistantName,
          });
          // this.nodes_index = index;
          // 兼容新旧两种方式访问 bottomInput
          if (this.$refs.chatInputArea) {
            this.$refs.chatInputArea.focusInput();
          } else if (this.$refs.bottomInput && this.$refs.bottomInput.$refs && this.$refs.bottomInput.$refs.input) {
            this.$refs.bottomInput.$refs.input.focus();
          }
          this.insertChat(
            IncomingNode[index_user_input].properties.input_value,
            this.inputValue,
            'chat',
            IncomingNode[index_user_input].properties.input_value,
            item.properties.headUrl,
            item.properties.assistantName
          );
          that.prevChatResult = that.prevChatResult + '滚动';
        }
      }
      return this.user_input_wait;
    },

    interaction_generation(node_id) {
      this.interaction_model_flag = true;
      this.handle_next_node_new(node_id);
    },
    interaction_comfirm(content) {
      //互动模式点击下一步
      if (!this.current_node.properties.is_history) {
        let json = [{
            role: 'user',
            content: this.inputValue
          },
          {
            role: 'assistant',
            content: content
          },
        ];
        this.lf.graphModel
          .getNodeModelById(this.current_node.id)
          .setProperties({
            content: JSON.stringify(json),
          });
      }
      this.handle_next_node_new(this.next_node.id); //没错，是this.next_node.id
    },
    /**
     * 工作流节点状态管理器 - 建立节点间的上下文关系
     *
     * 职责：
     * - 设置当前节点状态
     * - 建立节点间的上下文关系（上一个、当前、下一个）
     * - 处理入边节点的特殊逻辑（如用户引导）
     * - 为节点流转提供基础状态支持
     *
     * 层级：基础层 - 为控制层和执行层提供状态基础
     *
     * @param {Object} node - 要设置为当前节点的节点对象
     */
    handle_current_next_last(node) {
      if (node) {
        // 设置当前节点
        this.current_node = node;

        // 处理当前节点的入边节点（处理用户引导等特殊逻辑）
        this.handle_incoming_node()

        // 获取并设置上一个节点（入边节点）
        let last_node = this.lf.graphModel.getNodeIncomingNode(node.id);
        if (last_node.length != 0) {
          this.last_node = last_node[0];
        }

        // 获取并设置下一个节点（出边节点）
        let next_node = this.lf.graphModel.getNodeOutgoingNode(node.id);
        if (next_node.length != 0) {
          this.next_node = this.lf.getNodeDataById(next_node[0].id);
        }
      }
    },
    /**
     * 获取开始节点的内容
     * 根据下一个节点类型选择不同的默认问候语，如果开始节点有自定义内容则优先使用
     * 
     * @returns {string} 开始节点要显示的内容
     */
    getStartNodeContent() {
      // 根据下一个节点类型选择不同的默认问候语
      let defaultGreeting;
      if (this.next_node && (this.next_node.type === 'UserTask' || this.next_node.type === 'agent_card')) {
        // 如果下一个节点是 UserTask 或 agent_card，使用 Opening_remarks2
        const agentName = this.agent_data?.muti_name || this.agent_data?.name || 'AI助手';
        defaultGreeting = (this.lang.Opening_remarks2 || '你好！我是"${name}"。').replace('${name}', agentName);
      } else {
        // 如果不是 UserTask 或 agent_card，使用其他默认文案
        defaultGreeting = this.lang.default_greeting_in_workflow || 'Workflow execution started';
      }
      
      // 优先使用开始节点的自定义内容，如果没有则使用默认问候语
      const startNodeInputValue = this.lf.getNodeDataById('node_id_1').properties.input_value;
      return startNodeInputValue || defaultGreeting;
    },
    async handle_jump_condition(node_id, content_arr, inputValue) {
      const jump_condition = this.lf.getNodeDataById(node_id).properties.dispo_conditional||[];
      for (let i = 0; i < jump_condition.length; i++) {
        switch (jump_condition[i].conditional_option_value) {
          case this.lang.conditional_arr.conditional_option[0]:
            //失败次数
            break;
          case this.lang.conditional_arr.conditional_option[1]:
            //成功
            break;
          case this.lang.conditional_arr.conditional_option[2]:
            //用户输入
            if (jump_condition[i].option_value == inputValue) {
              this.handle_answer_crad_direction(
                jump_condition[i].direction_value
              );
              return true;
            }
            break;
          case this.lang.conditional_arr.conditional_option[3]:
            //回答轮次
            if (
              content_arr.length / 2 ==
              Number(jump_condition[i].option_value) ||
              content_arr.length == 20
            ) {
              this.handle_answer_crad_direction(
                jump_condition[i].direction_value
              );
              return true;
            }
            break;
          case this.lang.conditional_arr.conditional_option[4]:
            //语义判断
            var result = await this.handle_semantic_judgment(
              content_arr,
              jump_condition[i].option_value
            );
            if (result === jump_condition[i].direction_value) {
              this.handle_answer_crad_direction(
                jump_condition[i].direction_value
              );
              return result;
            }
            break;
          default:
            break;
        }
      }
    },
    async handle_semantic_judgment(content_arr, option_value) {
      return await new Promise((resolve) => {
        const prompt = [{
            role: 'system',
            content: option_value,
          },
          ...content_arr,
        ];
        let uid = uuidv4();
        let data = JSON.stringify({
          model: 'gpt-4o-2024-11-20',
          temperature: 0,
          max_tokens: 4096,
          top_p: 1,
          frequency_penalty: 0,
          presence_penalty: 0,
          messages: prompt,
          uid: uid,
          mind_map_question: false,
          stream: false,
        });
        let config = {
          method: 'post',
          url: this.GLOBAL.Base_Url + 'chat',
          headers: {
            'Content-Type': 'application/json',
            hwMac: store.state.user.organizeid,
          },
          data: data,
        };
        this.$axios(config)
          .then((response) => {
            resolve(response.data.FunctionResponse.choices[0].message.content);
          })
          .catch(function (error) {
            console.log(error);
            resolve(false);
          });
      });
    },
    //处理配置的方向
    handle_answer_crad_direction(direction_value) {
      this.answer_card_arr = []; // [已废弃] polygon 答题卡片残留，保留因本方法被 handle_jump_condition 共用
      // let last_node = {};
      this.answer_card_flag = false; // [已废弃] 同上
      switch (direction_value) {
        case this.lang.conditional_arr.direction[0]:
          //'下一级'
          this.nodes_index = this.nodes_index + 1;
          this.push_ai_content(
            this.lang.jump_condition + ':' + direction_value,
            this.lang.System_tip
          );
          this.handle_next_node_new(this.next_node.id);
          break;
        case this.lang.conditional_arr.direction[1]:
          //'上一级'
          this.nodes_index = this.nodes_index - 1;
          this.push_ai_content(
            this.lang.jump_condition + ':' + direction_value,
            this.lang.System_tip
          );
          this.handle_next_node_new(this.last_node.id);
          break;
        default:
          break;
      }
    },
    //处理链接boss卡片的链
    handle_boss_agent(id) {
      this.aiChatMessages.pop();
      let data = this.lf.getGraphData();
      let edge = data.edges;
      let node = data.nodes;
      let tag, agent;
      try {
        tag = edge.filter((item) => item.sourceAnchorId === id);
        agent = node.filter((item) => {
          return tag.some((tag_item) => {
            return item.id === tag_item.targetNodeId;
          });
        });
      } catch {
        id = JSON.parse(id).id;
        tag = edge.filter((item) => item.sourceAnchorId === id);
        agent = node.filter((item) => {
          return tag.some((tag_item) => {
            return item.id === tag_item.targetNodeId;
          });
        });
      }
      this.loading = false;
      this.lf.graphModel
        .getNodeModelById(this.current_node.id)
        .setProperties({
          is_run: false,
        });
      if (agent.length) {
        this.handle_boss_node(agent);
      } else {
        this.$message.error(this.lang.workflowStopNoCondition);
      }
    },
    handle_boss_node(agent) {
      this.handle_next_node_new(agent[0].id);
    },
    push_ai_content(problem, name = this.lang.System_tip,filename="") {
			console.log("测试测试测试从删除删除")
      this.aiChatMessages.push({
        role: 'user',
        content: '',
        uid: '',
        AI: 'AI',
        aiContent: problem,
        oldContent: '',
        isShowSynchronization: false,
        filename: filename,
        is_mind_map: false,
        fileid: name,
      });
      //this.prevChatResult = this.prevChatResult + '滚动';
    },
    // [已废弃] polygon 答题卡片
    // handle_answer_card() {
    //   this.$message.info(this.lang.Please_answer2);
    //   if (this.$refs.chatInputArea) {
    //     this.$refs.chatInputArea.focusInput();
    //   } else if (this.$refs.bottomInput && this.$refs.bottomInput.$refs && this.$refs.bottomInput.$refs.input) {
    //     this.$refs.bottomInput.$refs.input.focus();
    //   }
    //   if (this.answer_card_arr.length == 0) {
    //     this.answer_card_arr.push({
    //       role: 'system',
    //       content: this.lang.answer_card_desc,
    //     }, {
    //       role: 'user',
    //       content: `题目：${this.sse_result}。`,
    //     });
    //   } else if (this.answer_card_arr.length > 0) {
    //     this.answer_card_arr.push({
    //       role: 'user',
    //       content: `题目：${this.sse_result}。`,
    //     });
    //   }
    // },
    //处理boss卡片
    handle_boss_card(problem, id) {
      this.loading = true;
      this.aiChatMessages.push({
        role: 'user',
        content: this.lang.Control_card_judgment,
        uid: '',
        AI: 'AI',
        aiContent: '</br>',
        oldContent: '',
        isShowSynchronization: false,
        filename: '',
        is_mind_map: false,
        fileid: '',
      });
      this.prevChatResult = this.prevChatResult + '滚动';
      let nodes = this.lf.getGraphData().nodes;
      const boss_arr = nodes.find((item) => item.id === id);
      const fields = JSON.stringify(boss_arr.properties.fields);
      const prompt = [{
          role: 'system',
          content: '你的任务是匹配用户的问题和所给条件，从所给条件中找到和用户问题匹配度最高的那个条件，返回给我，记住：你只需要返回匹配条件的id给我，不需要多余的信息。',
        },
        {
          role: 'user',
          content: `。
          用户问题：<question>${problem}</question>
          条件：<condition>${fields}</condition>
          `,
        },
      ];
      let uid = uuidv4();
      let data = JSON.stringify({
        model: 'gpt-4o-2024-08-06',
        temperature: 0,
        max_tokens: 4096,
        top_p: 1,
        frequency_penalty: 0,
        presence_penalty: 0,
        messages: prompt,
        uid: uid,
        mind_map_question: false,
        stream: false,
      });
      let config = {
        method: 'post',
        url: this.GLOBAL.Base_Url + 'chat',
        headers: {
          'Content-Type': 'application/json',
          hwMac: store.state.user.organizeid,
        },
        data: data,
      };
      this.$axios(config)
        .then((response) => {
          this.handle_boss_agent(
            response.data.FunctionResponse.choices[0].message.content
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handle_echart_code(uid, ai_content) {
      console.log('[handle_echart_code] uid:', uid);
      console.log('[handle_echart_code] ai_content:', ai_content);
      window.chartDom = document.getElementById(`echart_card${uid}`);
      if (ai_content.includes('<echart_code>')) {
        console.log('[handle_echart_code] 分支: <echart_code>');
        const data = ai_content.split('<echart_code>');
        const index = this.aiChatMessages.findIndex((item) => item.uid == uid);
        this.aiChatMessages[index].echart_text = data[0];
        const data2 = data[1].split('</echart_code>');
        const echart_data = data2[0];
        this.aiChatMessages[index].echart_text2 = data2[1];
        console.log('[handle_echart_code] echart_data:', echart_data);
        let handleEchart = new Function(echart_data);
        handleEchart();
      } else {
        console.log('[handle_echart_code] 分支: JSON.parse');
        let myChart = echarts.init(window.chartDom);
        let option = JSON.parse(ai_content);
        option && myChart.setOption(option);
      }
    },
    // [已废弃] polygon 答题卡片
    // handle_answer_card_input(problem) {
    //   //答题卡片的输入
    //   let have_user_input = this.dispo_conditional.filter(
    //     (item) => item.conditional_option_value == '用户输入'
    //   );
    //   if (have_user_input.length) {
    //     if (have_user_input[0].option_value === problem) {
    //       this.handle_answer_crad_direction(have_user_input[0].direction_value);
    //       return;
    //     }
    //   }
    //   this.loading = true;
    //   this.answer_card_arr.at(-1).content += `回答：${problem}。`;
    //   let uid = uuidv4();
    //   this.aiChatMessages.push({
    //     role: 'user',
    //     content: problem,
    //     uid: uid,
    //     AI: 'AI',
    //     aiContent: '</br>',
    //     oldContent: '',
    //     isShowSynchronization: false,
    //     filename: require('../assets/img/ai_agent_header.png'),
    //     is_mind_map: false,
    //     fileid: this.lang.ai_assistant,
    //   });
    //   this.prevChatResult = this.prevChatResult + '滚动';
    //   let data = JSON.stringify({
    //     model: 'gpt-4o-2024-08-06',
    //     temperature: 0,
    //     max_tokens: 4096,
    //     top_p: 1,
    //     frequency_penalty: 0,
    //     presence_penalty: 0,
    //     messages: this.answer_card_arr,
    //     uid: uid,
    //     mind_map_question: '',
    //     stream: false,
    //   });
    //   let config = {
    //     method: 'post',
    //     url: this.GLOBAL.Base_Url + 'chat',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       hwMac: store.state.user.organizeid,
    //     },
    //     data: data,
    //   };
    //   this.$axios(config)
    //     .then((response) => {
    //       this.loading = false;
    //       let answer =
    //         response.data.FunctionResponse.choices[0].message.content;
    //       this.aiChatMessages.at(-1).aiContent = answer;
    //       this.prevChatResult = this.prevChatResult + '滚动';
    //       this.answer_card_arr.push({
    //         role: 'assistant',
    //         content: answer,
    //       });
    //       this.insertChat(
    //         answer,
    //         this.inputValue,
    //         'chat',
    //         answer,
    //         require('../assets/img/ai_agent_header.png'),
    //         this.lang.ai_assistant
    //       );
    //       this.prevChatResult = this.prevChatResult + '滚动';
    //       let correct = this.answer_card_arr.filter((item) => {
    //         return item.role === 'assistant' && item.content === '正确';
    //       });
    //       let mistake = this.answer_card_arr.filter((item) => {
    //         return item.role === 'assistant' && item.content === '错误';
    //       });
    //
    //       try {
    //         //回答轮次
    //         this.dispo_conditional.forEach((item) => {
    //           if (item.conditional_option_value == this.lang.answer_round) {
    //             if (correct.length + mistake.length >= item.option_value) {
    //               this.inputValue = '';
    //               this.handle_answer_crad_direction(item.direction_value);
    //               throw new Error('Terminate function');
    //             }
    //           }
    //         });
    //       } catch (err) {
    //         if (err.message === 'Terminate function') {
    //           return;
    //         }
    //       }
    //
    //       let chenggong = this.dispo_conditional.filter((item) => {
    //         return (
    //           correct.length >= item.option_value &&
    //           item.conditional_option_value == '成功次数'
    //         );
    //       });
    //       let shibai = this.dispo_conditional.filter((item) => {
    //         return (
    //           mistake.length >= item.option_value &&
    //           item.conditional_option_value == '失败次数'
    //         );
    //       });
    //       this.inputValue = '';
    //       if (chenggong.length > 0 || shibai.length > 0) {
    //         let direction = chenggong.length ? chenggong : shibai;
    //         this.handle_answer_crad_direction(direction[0].direction_value);
    //       } else {
    //         if (this.interaction_model_flag) {
    //           this.handle_next_node_new(this.next_node.id);
    //         } else {
    //           this.handle_next_node_new(this.current_node.id);
    //         }
    //       }
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
    // },
    get_agent_chat_list(id, luid) {
      this.chat_list_loading = true;
      this.aiChatMessages = [];
      // 返回 Promise 以便外部链式调用
      return new Promise((resolve, reject) => {
        if (id) {
          var config = {
            method: 'post',
            url: this.GLOBAL.Base_Url + 'get_agent_chat',
            headers: {
              'Content-Type': 'application/json',
              'hwMac': this.$store.state.user.organizeid,
            },
            data: {
              userid: luid ? luid : this.$store.state.user.userId,
              groupid: id,
            },
          };
          this.$axios(config)
            .then((res) => {
              this.chat_list_loading = false;
              try {
                const chat_list = JSON.parse(res.data.FunctionResponse);
                chat_list.forEach((item) => {
                  let json = {
                    role: 'user',
                    userName: item.username,
                    content: decodeURIComponent(item.problem),
                    uid: id,
                    AI: 'AI',
                    aiContent: decodeURIComponent(item.answer),
                    reasoning: item.reasoning_content,
                    oldContent: decodeURIComponent(new DOMParser().parseFromString(
                      item.answer,
                      'text/html'
                    ).documentElement.textContent),
                    isShowSynchronization: false,
                    filename: item.filename,
                    index: this.aiChatMessages.length,
                    createtime: item.createtime,
                    is_mind_map: item.problem.includes('思维导图') ||
                      item.problem.includes('思維導圖') ||
                      item.problem.includes('mindMap') ?
                      true : false,
                    graph: item.problem == this.lang.knowledge_graph ? true : false,
                  }
                  try {
                    json.jsonData = item.jsonData ? JSON.parse(decodeURIComponent(item.jsonData)) : null;
                    // 从 jsonData 中读取 syncTranscriptionText 值
                    if (json.jsonData && json.jsonData.syncTranscriptionText !== undefined) {
                      json.syncTranscriptionText = json.jsonData.syncTranscriptionText;
                    } else {
                      // 如果没有 jsonData 或 syncTranscriptionText，使用默认值
                      json.syncTranscriptionText = false;
                    }
                    
                    // 从 jsonData 中读取 contentType 值
                    if (json.jsonData && json.jsonData.contentType !== undefined) {
                      json.contentType = json.jsonData.contentType;
                    } else {
                      // 如果没有 jsonData 或 contentType，使用默认值
                      json.contentType = 'text';
                    }

                    // 新增：从 jsonData 中恢复用户音频播放所需字段
                    if (json.jsonData && json.jsonData.audio) {
                      json.audio = json.jsonData.audio;
                    }
                    if (json.jsonData && json.jsonData.durationSec) {
                      json.durationSec = json.jsonData.durationSec;
                    }
                  } catch (error) {
                    console.error('Error parsing jsonData:', error);
                    json.jsonData = null;
                    json.syncTranscriptionText = false;
                    json.contentType = 'text';
                  }
                  this.aiChatMessages.push(json);
                });
                this.prevChatResult += '滚动';
                resolve(); // 成功后 resolve
              } catch (error) {
                console.log(error);
                reject(error); // 解析出错也 reject
              }
            })
            .catch((error) => {
              this.chat_list_loading = false;
              console.log(error);
              reject(error); // 请求出错也 reject
            });
        } else {
          this.chat_list_loading = false;
          resolve(); // 没有 id 也 resolve
        }
      });
    },
    async chat_no_stream(prompt=[], response_format = {
      "type": "text"
    }, model = AI_MODEL_CONSTANTS.DEFAULT_MODEL) {
      return await new Promise((resolve) => {
        let uid = uuidv4();
        let data = JSON.stringify({
          model: model,
          temperature: 0,
          max_tokens: 4096,
          top_p: 1,
          frequency_penalty: 0,
          presence_penalty: 0,
          messages: prompt,
          uid: uid,
          mind_map_question: '',
          stream: false,
          response_format: response_format
        });
        let config = {
          method: 'post',
          url: this.new_url + '/api/common/chat',
          headers: {
            'Content-Type': 'application/json'
          },
          data: data,
        };
        this.$axios(config)
          .then((response) => {
            let content = response.data.FunctionResponse.choices[0].message.content;

            // 清理可能的 markdown 格式
            if (content.includes('```json')) {
              // 提取 ```json 和 ``` 之间的内容
              const jsonMatch = content.match(/```json\s*([\s\S]*?)\s*```/);
              if (jsonMatch) {
                content = jsonMatch[1].trim();
              }
            } else if (content.includes('```')) {
              // 提取 ``` 和 ``` 之间的内容
              const codeMatch = content.match(/```\s*([\s\S]*?)\s*```/);
              if (codeMatch) {
                content = codeMatch[1].trim();
              }
            }

            resolve(content);
          })
          .catch( (error)=> {
            console.log(error);
            // this.$message.error('服务器繁忙');
            resolve(false);
          });
      });
    },
    async ai_generate_image(prompt) {
      return await new Promise((resolve) => {
        this.$axios
          .post(this.new_url + "/api/agents/generateImage", {
            prompt,
            size: "1024x1024"
          }).then(res => {
            resolve(res.data);
          }).catch(function (error) {
            console.log(error);
            resolve(false);
          });
      })
    },
    importworkflows(json, isedit, callback) {
      try {
        const _result_json = JSON.parse(json);

        let _timer = null;
        let _percentageValue = 0;
        let _step = 0;
        let _maxStep = 10;
        // let _dian = 1;

        let _notify = this.$notify({
          title: this.lang.import,
          dangerouslyUseHTMLString: true,
          message: `<p style="margin-bottom:5px">${_result_json.muti_name}</p><div style="display:flex"><span style="display:block;width:95px">${this.lang.beingImported}......</span> ${_percentageValue}%</div>`,
          position: 'bottom-right',
          duration: 0,
        });
        _timer = setInterval(() => {
          if (_percentageValue <= 20 && _step > _maxStep) {
            _percentageValue += 6;
            _step = 0;
          } else if (_percentageValue <= 40 && _step > _maxStep) {
            _percentageValue += 4;
            _step = 0;
          } else if (_percentageValue <= 60 && _step > _maxStep) {
            _percentageValue += 2;
            _step = 0;
          } else if (_percentageValue <= 80 && _step > _maxStep) {
            _percentageValue += 2;
            _step = 0;
          } else if (_percentageValue <= 99 && _step > _maxStep) {
            _percentageValue = 99;
            _step = 0;
          }
          _step++;
          // if(_dian>=6){
          // 	_dian = 1;
          // }else{
          // 	_dian++;
          // }
          _notify.dom
            .querySelector('.el-notification__content')
            .querySelector(
              'div'
            ).innerHTML = `<span style="display:block;width:100%">${this.lang.beingImported}......</span>${_percentageValue}%`;
        }, 100);

        this.$axios
          .post(this.new_url + '/api/agents/import_mutiAgent', {
            userid: this.user.userId,
            username: this.user.userName,
            muti_name: _result_json.muti_name,
            description: _result_json.description,
            headUrl: _result_json.headUrl,
            isPublish: 0,
            organizeid: this.user.organizeid,
            content: JSON.stringify(_result_json.content),
            isEditable: isedit,
          })
          .then((res) => {
            if (_timer) {
              clearInterval(_timer);
              _timer = null;
              _notify.dom
                .querySelector('.el-notification__content')
                .querySelector(
                  'div'
                ).innerText = `${this.lang.beingImported}...... 100%`;
              setTimeout(() => {
                _notify.close();
              }, 200);
            }
            callback ? callback(res) : ""
          })
          .catch((err) => {
            handleCreateAppError(err, this.lang);
            console.log(err);
            if (_timer) {
              clearInterval(_timer);
              _timer = null;
              setTimeout(() => {
                _notify.close();
              }, 200);
            }
          });
      } catch (error) {
        console.error('Error parsing JSON file:', error);
      }
    },
    async ingest_file(url, modelType, signal) {
      return new Promise((resolve, reject) => {
        const config = {
          method: "put",
          url: this.new_url + "/api/agentchats/upload_file",
          headers: {
            "Content-Type": "application/json",
          },
          data: {
            url: url,
            // url_list: [],
            modelType: modelType,
          },
          // 新增：支持取消
          signal: signal,
        };
        this.$axios(config)
          .then((response) => {
            resolve(response.data.result.id);
          })
          .catch((error) => {
            if (signal && error.name === 'CanceledError') {
              // 主动取消
              reject(new Error('取消注册资料库'));
            } else {
              this.$message.error(this.lang.serverBusy);
              console.log(error);
              reject(error);
            }
          });
      });
    },
    startWaveSurfer() {
      if (this.wavesurfer) return;
      const waveform = this.$refs && this.$refs.waveform;
      if (!waveform) return;
      this.wavesurfer = WaveSurfer.create({
        container: waveform,
        waveColor: '#1976f6', // 更接近气泡蓝
        interact: false,
        cursorWidth: 0,
        height: 40,
        barWidth: 6,         // 更粗
        barGap: 2,           // 间隔
        barRadius: 6,        // 圆角，接近圆点
        plugins: [
          // MicrophonePlugin.create()
        ]
      });
      // this.wavesurfer.microphone.on('deviceReady', () => {
      //   // 麦克风已准备好
      // });
      // this.wavesurfer.microphone.on('deviceError', (code) => {
      //   this.$message && this.$message.error('麦克风不可用');
      // });
      // this.wavesurfer.microphone.start();
    },
    stopWaveSurfer() {
      if (this.record) {
        this.record.stopRecording();
        this.record = null;
      }
      if (this.wavesurfer) {
        this.wavesurfer.empty();
        this.wavesurfer.destroy();
        this.wavesurfer = null;
      }
    },
    createWaveSurfer() {
      if (this.wavesurfer) {
        this.wavesurfer.destroy();
        this.wavesurfer = null;
        this.record = null;
      }
      const waveform = this.$refs.waveform;
      if (!waveform) return;
      this.wavesurfer = WaveSurfer.create({
        container: waveform,
        waveColor: '#1976f6', // 统一蓝色
        progressColor: '#1976f6',
        height: 40,
        barWidth: 6,
        barGap: 2,
        barRadius: 6,
        normalize: true,
      });
      this.record = this.wavesurfer.registerPlugin(
        RecordPlugin.create({
          renderRecordedAudio: false,
          scrollingWaveform: true,
          continuousWaveform: false,
          continuousWaveformDuration: 30,
          barWidth: 6,
          barGap: 2,
          barRadius: 6,
        })
      );
    },
    initUserAudioBubbleFields(audioUrl, durationSec) {
      return {
        role: 'user',
        content: '', // 用户音频气泡不需要文本内容
        aiContent: '',
        audio: audioUrl,
        aiAudio: null,
        durationSec: durationSec,
        aiDurationSec: 0,
        // oldContent: '',
        // isShowSynchronization: false,
        // filename: '',
        // is_mind_map: false,
        contentType: 'audio',
        // aiContentType: 'audio',
        time: Date.now(),
        showTranscription: false,
        // aiShowTranscription: false,
        transcription: '',
        aiTranscription: '',
        // createtime: this.formatTime(new Date()),
        aiShowTranscription: this.outputModeTranscribedText || (this.agent_data && this.agent_data.outputMode === 'text'),
        // inputMode: 'voice',
        outputMode: this.agent_data && this.agent_data.outputMode, // 记录生成时的 outputMode
        aiContentType: (this.agent_data && this.agent_data.modelType && this.agent_data.modelType.includes('audio')) ? 'audio' : 'text',
        inputModeTranscribedText: this.inputModeTranscribedText,
        outputModeTranscribedText: this.outputModeTranscribedText,
      };
    },

    initUserTextBubbleFields(content, uid = '') {
      return {
        role: 'user',
        content: content,
        uid: uid,
        AI: 'AI',
        aiContent: '</br>',
        oldContent: '',
        isShowSynchronization: false,
        filename: '',
        is_mind_map: false,
        time: Date.now(),
        createtime: this.formatTime(new Date())
      };
    },

    // // 初始化AI音频气泡字段
    // initAiAudioBubbleFields(audioUrl = '', durationSec = 0, transcription = '') {
    //   return {
    //     role: 'ai',
    //     type: 'audio',
    //     aiContent: '',
    //     audio: audioUrl,
    //     durationSec: durationSec,
    //     transcription: transcription,
    //     showTranscription: false,
    //     like: false,
    //     unlike: false,
    //     oldContent: '',
    //     isShowSynchronization: false,
    //     filename: '',
    //     is_mind_map: false,
    //     time: Date.now(),
    //     createtime: this.formatTime(new Date())
    //   };
    // },

    // // 初始化AI文本气泡字段
    // initAiTextBubbleFields(content = '') {
    //   return {
    //     role: 'ai',
    //     aiContent: content,
    //     like: false,
    //     unlike: false,
    //     oldContent: '',
    //     isShowSynchronization: false,
    //     filename: '',
    //     is_mind_map: false,
    //     time: Date.now(),
    //     createtime: this.formatTime(new Date())
    //   };
    // },

    // 格式化时间
    formatTime(date) {
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    },

    // 新增：处理音频流式响应的通用方法
    async handleAudioStreamResponse(response) {
      if (!response.body) {
        this.$message.error(this.lang.interfaceNoStreamReturn);
        return;
      }

      // 初始化 AudioContext
      if (!this._pcmAudioCtx) {
        this._pcmAudioCtx = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 24000 });
      }
      const audioCtx = this._pcmAudioCtx;

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let allChunks = [];
      let lastAudioUrl = '';

      // 添加缓冲区来处理不完整的JSON数据
      let buffer = '';
      
      // 初始化音频缓冲相关变量
      let preBufferFloat32 = [];
      // let bufferedSamples = 0;

      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;

        const text = decoder.decode(value);
        buffer += text;

        // 按行分割并处理完整的数据行
        const lines = buffer.split('\n');
        // 保留最后一行（可能不完整）到缓冲区
        buffer = lines.pop() || '';

        lines.forEach(line => {
          if (line.startsWith('data:')) {
            try {
              const json = JSON.parse(line.slice(5));

              // 音频流处理
              if (json.data) {
                const base64 = json.data;
                const binaryStr = atob(base64);
                const chunk = new Uint8Array(binaryStr.length);
                for (let i = 0; i < binaryStr.length; i++) {
                  chunk[i] = binaryStr.charCodeAt(i);
                }
                allChunks.push(chunk);
                
                const int16View = new Int16Array(chunk.buffer, chunk.byteOffset, Math.floor(chunk.length / 2));
                const float32 = new Float32Array(int16View.length);
                for (let i = 0; i < int16View.length; i++) {
                  float32[i] = int16View[i] / 32768;
                }

                // 只在第一次收到数据时，生成临时的URL用于气泡（可选）
                if (!lastAudioUrl) {
                  const emptyWav = new Blob([], { type: 'audio/wav' });
                  lastAudioUrl = URL.createObjectURL(emptyWav);
                  if (this.aiChatMessages && this.aiChatMessages.length > 0) {
                    const lastMsg = this.aiChatMessages[this.aiChatMessages.length - 1];
                    // 设置 AI 音频相关字段
                    lastMsg.aiContentType = 'audio'; // 标识为音频类型
                    lastMsg.audio = lastAudioUrl;
                    lastMsg.aiContent = ''; // 清空文本内容，显示音频
                    if (!lastMsg.aiTranscription) this.$set(lastMsg, 'aiTranscription', '');
                    if (!lastMsg.aiShowTranscription) this.$set(lastMsg, 'aiShowTranscription', false);
                  }
                }

                // 将音频数据添加到缓冲区，不立即播放
                preBufferFloat32.push(...float32);
                // bufferedSamples += float32.length;
              }

              // transcript流处理
              // 后端接口变化：transcript字段改为content字段
              console.log('[handleAudioStreamResponse] 处理JSON数据:', json);
              console.log('[handleAudioStreamResponse] aiChatMessages长度:', this.aiChatMessages ? this.aiChatMessages.length : 'undefined');

              if (json.content) { // 原：json.transcript
                console.log('[handleAudioStreamResponse] 收到content数据:', json.content);
                // 过滤掉SSE流结束的[DONE]响应，不显示
                if (json.content === '[DONE]') {
                  console.log('[handleAudioStreamResponse] 收到[DONE]标记，跳过处理');
                  return; // 直接返回，不处理[DONE]响应
                }
                if (this.aiChatMessages && this.aiChatMessages.length > 0) {
                  const lastMsg = this.aiChatMessages[this.aiChatMessages.length - 1];
                  console.log('[handleAudioStreamResponse] 最后一条消息:', lastMsg);
                  if (!lastMsg.aiTranscription) {
                    console.log('[handleAudioStreamResponse] 初始化aiTranscription字段');
                    this.$set(lastMsg, 'aiTranscription', '');
                  }
                  lastMsg.aiTranscription += json.content; // 原：json.transcript
                  console.log('[handleAudioStreamResponse] 更新aiTranscription:', lastMsg.aiTranscription);
                } else {
                  console.log('[handleAudioStreamResponse] aiChatMessages为空或不存在');
                }
              } else {
                console.log('[handleAudioStreamResponse] JSON数据中没有content字段:', json);
                // 检查其他可能的字段名
                if (json.transcript) {
                  console.log('[handleAudioStreamResponse] 发现transcript字段:', json.transcript);
                  if (this.aiChatMessages && this.aiChatMessages.length > 0) {
                    const lastMsg = this.aiChatMessages[this.aiChatMessages.length - 1];
                    if (!lastMsg.aiTranscription) this.$set(lastMsg, 'aiTranscription', '');
                    lastMsg.aiTranscription += json.transcript;
                    console.log('[handleAudioStreamResponse] 使用transcript字段更新aiTranscription:', lastMsg.aiTranscription);
                  }
                } else if (json.text) {
                  console.log('[handleAudioStreamResponse] 发现text字段:', json.text);
                  if (this.aiChatMessages && this.aiChatMessages.length > 0) {
                    const lastMsg = this.aiChatMessages[this.aiChatMessages.length - 1];
                    if (!lastMsg.aiTranscription) this.$set(lastMsg, 'aiTranscription', '');
                    lastMsg.aiTranscription += json.text;
                    console.log('[handleAudioStreamResponse] 使用text字段更新aiTranscription:', lastMsg.aiTranscription);
                  }
                } else if (json.message) {
                  console.log('[handleAudioStreamResponse] 发现message字段:', json.message);
                  if (this.aiChatMessages && this.aiChatMessages.length > 0) {
                    const lastMsg = this.aiChatMessages[this.aiChatMessages.length - 1];
                    if (!lastMsg.aiTranscription) this.$set(lastMsg, 'aiTranscription', '');
                    lastMsg.aiTranscription += json.message;
                    console.log('[handleAudioStreamResponse] 使用message字段更新aiTranscription:', lastMsg.aiTranscription);
                  }
                }
              }
            } catch (e) {
              console.warn('[handleAudioStreamResponse] data字段解析失败', e, line);
            }
          }
        });
      }

      // 处理缓冲区中可能剩余的完整数据
      if (buffer.trim()) {
        const lines = buffer.split('\n');
        lines.forEach(line => {
          if (line.startsWith('data:')) {
            try {
              const json = JSON.parse(line.slice(5));

              // 音频流处理
              if (json.data) {
                const base64 = json.data;
                const binaryStr = atob(base64);
                const chunk = new Uint8Array(binaryStr.length);
                for (let i = 0; i < binaryStr.length; i++) {
                  chunk[i] = binaryStr.charCodeAt(i);
                }
                allChunks.push(chunk);
                const int16View = new Int16Array(chunk.buffer, chunk.byteOffset, Math.floor(chunk.length / 2));
                const float32 = new Float32Array(int16View.length);
                for (let i = 0; i < int16View.length; i++) {
                  float32[i] = int16View[i] / 32768;
                }
                preBufferFloat32.push(...float32);
                // bufferedSamples += float32.length;

                if (!lastAudioUrl) {
                  const emptyWav = new Blob([], { type: 'audio/wav' });
                  lastAudioUrl = URL.createObjectURL(emptyWav);
                  if (this.aiChatMessages && this.aiChatMessages.length > 0) {
                    const lastMsg = this.aiChatMessages[this.aiChatMessages.length - 1];
                    lastMsg.aiContentType = 'audio';
                    lastMsg.audio = lastAudioUrl;
                    lastMsg.aiContent = '';
                    if (!lastMsg.aiTranscription) this.$set(lastMsg, 'aiTranscription', '');
                    if (!lastMsg.aiShowTranscription) this.$set(lastMsg, 'aiShowTranscription', false);
                  }
                }
              }

              // transcript流处理
              if (json.content) {
                console.log('[handleAudioStreamResponse] 缓冲区处理 - 收到content数据:', json.content);
                if (json.content === '[DONE]') {
                  console.log('[handleAudioStreamResponse] 缓冲区处理 - 收到[DONE]标记，跳过处理');
                  return;
                }
                if (this.aiChatMessages && this.aiChatMessages.length > 0) {
                  const lastMsg = this.aiChatMessages[this.aiChatMessages.length - 1];
                  if (!lastMsg.aiTranscription) this.$set(lastMsg, 'aiTranscription', '');
                  lastMsg.aiTranscription += json.content;
                  console.log('[handleAudioStreamResponse] 缓冲区处理 - 更新aiTranscription:', lastMsg.aiTranscription);
                }
              } else {
                console.log('[handleAudioStreamResponse] 缓冲区处理 - JSON数据中没有content字段:', json);
                // 检查其他可能的字段名
                if (json.transcript) {
                  console.log('[handleAudioStreamResponse] 缓冲区处理 - 发现transcript字段:', json.transcript);
                  if (this.aiChatMessages && this.aiChatMessages.length > 0) {
                    const lastMsg = this.aiChatMessages[this.aiChatMessages.length - 1];
                    if (!lastMsg.aiTranscription) this.$set(lastMsg, 'aiTranscription', '');
                    lastMsg.aiTranscription += json.transcript;
                    console.log('[handleAudioStreamResponse] 缓冲区处理 - 使用transcript字段更新aiTranscription:', lastMsg.aiTranscription);
                  }
                } else if (json.text) {
                  console.log('[handleAudioStreamResponse] 缓冲区处理 - 发现text字段:', json.text);
                  if (this.aiChatMessages && this.aiChatMessages.length > 0) {
                    const lastMsg = this.aiChatMessages[this.aiChatMessages.length - 1];
                    if (!lastMsg.aiTranscription) this.$set(lastMsg, 'aiTranscription', '');
                    lastMsg.aiTranscription += json.text;
                    console.log('[handleAudioStreamResponse] 缓冲区处理 - 使用text字段更新aiTranscription:', lastMsg.aiTranscription);
                  }
                } else if (json.message) {
                  console.log('[handleAudioStreamResponse] 缓冲区处理 - 发现message字段:', json.message);
                  if (this.aiChatMessages && this.aiChatMessages.length > 0) {
                    const lastMsg = this.aiChatMessages[this.aiChatMessages.length - 1];
                    if (!lastMsg.aiTranscription) this.$set(lastMsg, 'aiTranscription', '');
                    lastMsg.aiTranscription += json.message;
                    console.log('[handleAudioStreamResponse] 缓冲区处理 - 使用message字段更新aiTranscription:', lastMsg.aiTranscription);
                  }
                }
              }
            } catch (e) {
              console.warn('[handleAudioStreamResponse] 缓冲区数据处理失败', e, line);
            }
          }
        });
      }

      // 接收完成后，一次性播放完整的音频
      if (preBufferFloat32.length > 0 && this.shouldPlayAudio()) {
        console.log('[handleAudioStreamResponse] 开始播放完整音频，总样本数:', preBufferFloat32.length);
        
        // 创建完整的音频缓冲区
        const completeBuffer = audioCtx.createBuffer(1, preBufferFloat32.length, 24000);
        completeBuffer.getChannelData(0).set(preBufferFloat32);
        
        // 播放完整音频
        const source = audioCtx.createBufferSource();
        source.buffer = completeBuffer;
        source.connect(audioCtx.destination);
        source.onended = () => {
          console.log('[handleAudioStreamResponse] 完整音频播放完成');
        };
        source.start();
      }

      // 全部收完后，合成完整wav并更新气泡url
      if (allChunks.length > 0) {
        const totalLength = allChunks.reduce((sum, arr) => sum + arr.length, 0);
        const audioData = new Uint8Array(totalLength);
        let offset = 0;
        for (const chunk of allChunks) {
          audioData.set(chunk, offset);
          offset += chunk.length;
        }
        let trimmedAudioData = audioData;
        if (audioData.length % 2 !== 0) {
          trimmedAudioData = audioData.slice(0, audioData.length - 1);
        }
        const int16View = new Int16Array(trimmedAudioData.buffer, trimmedAudioData.byteOffset, Math.floor(trimmedAudioData.length / 2));
        const float32 = new Float32Array(int16View.length);
        for (let i = 0; i < int16View.length; i++) {
          float32[i] = int16View[i] / 32768;
        }
        const audioBuffer = {
          sampleRate: 24000,
          channelData: [float32],
        };
        const wavBuffer = await WavEncoder.encode(audioBuffer);
        const blobWav = new Blob([wavBuffer], { type: "audio/wav" });
        const url = URL.createObjectURL(blobWav);

        // 更新最后一条消息为完整音频
        if (this.aiChatMessages && this.aiChatMessages.length > 0) {
          const lastMsg = this.aiChatMessages[this.aiChatMessages.length - 1];
          lastMsg.aiContentType = 'audio'; // 确保标识为音频类型
          lastMsg.aiContent = ''; // 清空文本内容
          lastMsg.aiAudio = url; // 设置完整音频 URL
          // 自动获取音频时长
          const audio = new Audio(url);
          audio.addEventListener('loadedmetadata', () => {
            this.$set(lastMsg, 'aiDurationSec', Math.round(audio.duration));
            this.loading = false;
          });
        }
      }
    },

    // 新增：简单的音频转录方法，参考 send_voice 和 stop_voice 的实现
    async transcribeAudioToText(audioBlob) {
      // var live = true;
      // // microsoft的实时语音转写, 实时转录开关需要打开
      // if (live) {
      //   this.initSpeechRecognizerTranscriber();
      //   // return;
      // }
      // 无论传入什么 audioBlob，始终用 /record_out.wav 进行测试
      // debugger
      const testBlob = audioBlob;
      // const response = await fetch('/katiesteve.wav');
      // const response = await fetch('/record_out.wav');
      // const response = await fetch('/what_news.wav');
      // const response = await fetch('/oneplusone.mp3');
      // const testBlob = await response.blob();
      // return new Promise((resolve, reject) => {
      //   try {
      //     // 使用现有的语音配置，作为属性访问
      //     const speechConfig = this.speechConfig;
      //     const audioConfig = SpeechSDK.AudioConfig.fromWavFileInput(testBlob);
      //     console.log('[transcribeAudioToText] speechConfig:', speechConfig);
      //     console.log('[transcribeAudioToText] audioConfig:', audioConfig);
      //     console.log('[transcribeAudioToText] audioBlob:', testBlob);

      //     // 使用 ConversationTranscriber（官方 demo 方式）
      //     const conversationTranscriber = new SpeechSDK.ConversationTranscriber(speechConfig, audioConfig);
      //     let transcription = '';

      //     console.log("Transcribing from: record_out.wav");

      //     conversationTranscriber.sessionStarted = function (s, e) {
      //       console.log("SessionStarted event");
      //       console.log("SessionId:" + e.sessionId);
      //     };

      //     conversationTranscriber.sessionStopped = function (s, e) {
      //       console.log("SessionStopped event");
      //       console.log("SessionId:" + e.sessionId);
      //       conversationTranscriber.stopTranscribingAsync();
      //     };

      //     conversationTranscriber.canceled = function (s, e) {
      //       console.log("Canceled event");
      //       console.log(e.errorDetails);
      //       reject(new Error('识别被取消: ' + e.errorDetails));
      //       conversationTranscriber.stopTranscribingAsync();
      //     };

      //     conversationTranscriber.transcribed = function (s, e) {
      //       console.log("TRANSCRIBED: Text=" + e.result.text + " Speaker ID=" + e.result.speakerId);
      //       transcription += e.result.text + ' ';
      //     };

      //     // Start conversation transcription
      //     conversationTranscriber.startTranscribingAsync(
      //       function () {
      //         console.log("开始转录...");
      //       },
      //       function (err) {
      //         console.error('[transcribeAudioToText] startTranscribingAsync error:', err);
      //         reject(new Error('开始转录失败: ' + err));
      //       }
      //     );

      //     // 监听转录完成
      //     conversationTranscriber.sessionStopped = function (s, e) {
      //       console.log("SessionStopped event");
      //       console.log("SessionId:" + e.sessionId);
      //       resolve(transcription.trim());
      //       conversationTranscriber.stopTranscribingAsync();
      //     };

      //   } catch (error) {
      //     reject(new Error('创建转录器失败: ' + error.message));
      //   }
      // });
      this.transcribeAudioWithPushStream(testBlob)
    },

    // 新增：按照官方 demo 使用 PushStream 方式的音频转录方法
    async transcribeAudioWithPushStream(audioBlob) {
      // debugger
      let that = this;
      return new Promise((resolve, reject) => {
        let isSessionClosed = false;
        try {
          // 重新初始化 SpeechConfig
          // const key = process.env.VUE_APP_AZURE_SPEECH_KEY;
          // const region = process.env.VUE_APP_AZURE_SPEECH_REGION;
          // const key = '5b401f52c9064cec9247f4190cf99ea4';
          // const region = 'eastasia';


          // if (!key || !region) {
          //   reject(new Error('Azure Speech 环境变量未设置: VUE_APP_AZURE_SPEECH_KEY 或 VUE_APP_AZURE_SPEECH_REGION'));
          //   return;
          // }

          // console.log('[transcribeAudioWithPushStream] 初始化配置:', { key: key.substring(0, 8) + '...', region });
          // const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(key, region);
          this.speechConfig.speechRecognitionLanguage = "zh-CN";

          // 创建 PushStream
          const pushStream = SpeechSDK.AudioInputStream.createPushStream();

          // 创建音频配置
          const audioConfig = SpeechSDK.AudioConfig.fromStreamInput(pushStream);

          // 创建对话转录器
          const conversationTranscriber = new SpeechSDK.ConversationTranscriber(this.speechConfig, audioConfig);

          let transcription = '';
          // const filename = "record_out.wav"; // 测试文件名

          // console.log("Transcribing from: " + filename);

          // 事件处理
          conversationTranscriber.sessionStarted = function (s, e) {
            console.log("SessionStarted event");
            console.log("SessionId:" + e.sessionId);
          };

          conversationTranscriber.sessionStopped = function (s, e) {
            if (isSessionClosed) return;
            isSessionClosed = true;
            console.log("SessionStopped event");
            console.log("SessionId:" + e.sessionId);
            resolve(transcription.trim());
          };

          conversationTranscriber.canceled = function (s, e) {
            if (isSessionClosed) return;
            isSessionClosed = true;
            console.warn('识别被取消:', e.errorDetails || '(无详细信息)');
            // reject(new Error('识别被取消'));
            resolve('canceled');
          };

          conversationTranscriber.transcribed = function (s, e) {
            console.log("TRANSCRIBED: Text=" + e.result.text + " Speaker ID=" + e.result.speakerId);
            // transcription += e.result.text + ' ';
            // 实时更新最后一条消息的 transcription 字段
            if (that && that.aiChatMessages && that.aiChatMessages.length > 0) {
              const lastMsg = that.aiChatMessages[that.aiChatMessages.length - 1];
              if (!lastMsg.transcription) that.$set(lastMsg, 'transcription', '');
              lastMsg.transcription += e.result.text + ' ';
            }
          };

          // 开始转录
          conversationTranscriber.startTranscribingAsync(
            function () {
              console.log("开始转录...");
              // 读取传入的audioBlob并写入 PushStream
              if (audioBlob) {
                audioBlob.arrayBuffer()
                  .then(arrayBuffer => {
                    const uint8Array = new Uint8Array(arrayBuffer);
                    pushStream.write(uint8Array);
                    pushStream.close();
                  })
                  .catch(error => {
                    console.error('读取audioBlob失败:', error);
                    reject(new Error('读取audioBlob失败: ' + error.message));
                  });
              } else {
                reject(new Error('audioBlob未传入'));
              }
            },
            function (err) {
              console.error('[transcribeAudioWithPushStream] startTranscribingAsync error:', err);
              reject(new Error('开始转录失败: ' + err));
            }
          );

        } catch (error) {
          reject(new Error('创建转录器失败: ' + error.message));
        }
      });
    },
    // 实时转录开始
    initSpeechRecognizerTranscriber() {
      let that = this;
      // debugger
      this.speechConfig.speechRecognitionLanguage = "zh-CN";

      this.speechRecognizer = SpeechSDK.ConversationTranscriber.FromConfig(this.speechConfig, this.autoDetectSourceLanguageConfig, this.audioConfig);

      this.speechRecognizer.sessionStarted = (s, e) => {
        console.log("SessionStarted event");
        console.log("SessionId:" + e.sessionId);
        // this.record_start = false;
      };
      this.speechRecognizer.sessionStopped = () => {
        console.log("SessionStopped event");
        this.speechRecognizer.stopTranscribingAsync();
        this.is_text = true;
        this.loading = false;
      };
      this.speechRecognizer.canceled = (s, e) => {
        console.log("Canceled event");
        console.log(e.errorDetails);
        this.speechRecognizer.stopTranscribingAsync();
        this.loading = false;
      };
      this.speechRecognizer.transcribed = (s, e) => {
        // debugger
        if (e.result.text) {
          console.log('[语音转写] 收到文本片段:', e.result.text);
          if (that && that.aiChatMessages && that.aiChatMessages.length > 0) {
            const lastMsg = that.aiChatMessages[that.aiChatMessages.length - 1];
            if (!lastMsg.transcription) that.$set(lastMsg, 'transcription', '');
            lastMsg.transcription += e.result.text + ' ';
          }
        }
      };
      // Start conversation transcription
      this.speechRecognizer.startTranscribingAsync(
        function () {},
        function (err) {
          console.trace("err - starting transcription: " + err);
        }
      );
    },
    shouldPlayAudio() {
      if (this.aiChatMessages && this.aiChatMessages.length > 0) {
        const lastMsg = this.aiChatMessages[this.aiChatMessages.length - 1];
        return lastMsg.outputMode === 'voice';
      }
      return true;
    },
    playNextBuffer(audioCtx, bufferQueue) {
      if (!bufferQueue.length) {
        this.isPlayingAudio = false;
        return;
      }

      // 防止重复播放
      if (this.isPlayingAudio) {
        return;
      }

      this.isPlayingAudio = true;
      const buffer = bufferQueue.shift();
      const source = audioCtx.createBufferSource();
      source.buffer = buffer;
      source.connect(audioCtx.destination);
      source.onended = () => {
        this.isPlayingAudio = false;
        // 延迟一小段时间再播放下一个buffer，避免重叠
        setTimeout(() => {
          this.playNextBuffer(audioCtx, bufferQueue);
        }, 10);
      };
      source.start();
    },
    saveUserAiCharacter(userId, url) {
      return this.$axios({
        method: 'post',
        url: this.new_url + '/api/aicharacters/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          user_id: userId,
          url: url
        }
      })
      .then(res => {
        this.$message.success(this.lang.aiTaskSaveSuccess);
        return res.data;
      })
      .catch(err => {
        this.$message.error(this.lang.aiTaskSaveFail);
        console.error('保存AI任务失败:', err);
        throw err;
      });
    },

    // 处理完整音频响应（非流式）
    async handleCompleteAudioResponse(params) {
      try {
        console.log('[handleCompleteAudioResponse] 开始处理完整音频响应');
        
        // 发送请求获取完整响应
        const response = await fetch(this.new_url + "/api/agentchats/ai_agent_chat", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...params,
            stream: false // 关闭流式处理
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log('[handleCompleteAudioResponse] 完整响应:', result);

        // 处理AI响应
        if (result.aiContent) {
          // 更新最后一条消息的AI内容
          if (this.aiChatMessages && this.aiChatMessages.length > 0) {
            const lastMsg = this.aiChatMessages[this.aiChatMessages.length - 1];
            lastMsg.aiContent = result.aiContent;
            lastMsg.aiContentType = result.aiContentType || 'text';
            lastMsg.aiAudio = result.aiAudio || null;
            lastMsg.aiDurationSec = result.aiDurationSec || null;
            lastMsg.aiTranscription = result.aiTranscription || null;
            lastMsg.aiShowTranscription = result.aiShowTranscription || false;
            lastMsg.reasoning = result.reasoning || '';
          }
        }

        // 如果有AI音频，等待完整接收后播放
        if (result.aiAudio) {
          await this.playCompleteAudioResponse(result.aiAudio);
        }

        this.loading = false;
        this.$message.success(this.lang.audioProcessingComplete);

      } catch (e) {
        this.$message.error(this.lang.audioProcessingError + e.message);
        console.error('[handleCompleteAudioResponse] 完整音频处理出错', e);
        this.loading = false;
      }
    },

    // 处理流式音频响应（原有逻辑）
    async handleStreamingAudioResponse(params) {
      try {
        console.log('[handleStreamingAudioResponse] 开始处理流式音频响应');
        
        // 初始化 AudioContext
        if (!this._pcmAudioCtx) {
          this._pcmAudioCtx = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 24000 });
        }

        const res = await fetch(this.new_url + "/api/agentchats/ai_agent_chat", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(params),
        });

        // 使用通用的音频流处理方法
        await this.handleAudioStreamResponse(res, true);

      } catch (e) {
        this.$message.error(this.lang.recordingfail + e.message);
        console.error('[handleStreamingAudioResponse] 流式音频处理出错', e);
        this.loading = false;
      }
    },

    // 播放完整音频响应
    async playCompleteAudioResponse(audioData) {
      try {
        console.log('[playCompleteAudioResponse] 开始播放完整音频');
        
        // 初始化 AudioContext
        if (!this._pcmAudioCtx) {
          this._pcmAudioCtx = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 24000 });
        }

        // 解码音频数据
        const audioBuffer = await this._pcmAudioCtx.decodeAudioData(audioData);
        
        // 创建音频源并播放
        const source = this._pcmAudioCtx.createBufferSource();
        source.buffer = audioBuffer;
        source.connect(this._pcmAudioCtx.destination);
        
        // 播放完成后的回调
        source.onended = () => {
          console.log('[playCompleteAudioResponse] 音频播放完成');
          this.isPlayingAudio = false;
        };

        // 开始播放
        this.isPlayingAudio = true;
        source.start();
        
        console.log('[playCompleteAudioResponse] 音频开始播放，时长:', audioBuffer.duration, '秒');

      } catch (e) {
        console.error('[playCompleteAudioResponse] 播放音频出错:', e);
        this.isPlayingAudio = false;
      }
    },

    // 重置录音状态和清理临时消息的公共方法
    resetRecordingState(options = {}) {
      const {
        clearCurrentMessage = true,
        showMessage = false,
        messageType = 'info',
        messageText = ''
      } = options;

      // 重置录音状态
      this.record_start = true;
      this.audioPhase = 'idle';
      
      // 清理临时消息
      if (clearCurrentMessage && this.currentMessage) {
        console.log('[mixin] 清空临时消息');
        this.currentMessage = null;
      }
      
      // 显示消息（可选）
      if (showMessage && this.$message) {
        this.$message[messageType](messageText);
      }
      
      // 清理其他相关状态
      this.isSending = false;
      this.loading = false;
      
      console.log('[mixin] 录音状态已重置');
    },

    // 处理录音停止后的状态重置
    handleRecordingStopState(result, options = {}) {
      const {
        isVoiceInteractionMode = false,
        clearCurrentMessage = true
      } = options;
      
      if (isVoiceInteractionMode) {
        // 语音交互模式：保持录音布局以显示后续阶段
        console.log('[mixin] 语音交互模式，保持录音布局');
      } else {
        // 非语音交互模式：立即恢复初始布局
        this.resetRecordingState({
          clearCurrentMessage,
          showMessage: false
        });
      }
      
      return result;
    },

    // 创建对话消息的公共方法（一条消息包含一次完整的问答对话）
    createDialogueMessage(options = {}) {
      const {
        content = '', // 用户输入内容
        uid = null,
        voiceInteractionMode = false,
        syncTranscriptionText = false,
        contentType = 'text' // 内容类型：text 或 audio
      } = options;

      const message = {
        uid: uid || this.generateUUID(),
        content: voiceInteractionMode ? '' : content, // 语音交互模式下content为空，非语音交互模式下为输入内容
        aiContent: '</br>', // AI响应占位符
        oldContent: '',
        isShowSynchronization: false,
        filename: '',
        is_mind_map: false,
        time: Date.now(),
        createtime: new Date().toLocaleTimeString(),
        contentType: contentType, // 设置内容类型
        // 新增：确保初次插入消息时有明确布尔值，避免为 null 导致转录不显示
        syncTranscriptionText: this.agent_data.syncTranscriptionText
      };

      // 如果是语音交互模式，添加额外的字段
      if (voiceInteractionMode) {
        message.audio = null; // 用户音频
        message.aiAudio = null; // AI音频
        message.showTranscription = syncTranscriptionText;
        message.transcription = content; // 用户语音转录文本 - 修复：将转录文本正确设置到transcription字段
      }

      console.log('[mixin] 创建对话消息:', message);
      return message;
    },

    // 智能添加消息到聊天列表的公共方法
    addMessageToChat(message, options = {}) {
      const {
        voiceInteractionMode = false,
        isImmediate = true
      } = options;

      if (voiceInteractionMode && !isImmediate) {
        // 语音交互模式且不立即添加：存储为临时消息
        this.currentMessage = message;
        console.log('[mixin] 语音交互模式，消息存储为临时消息');
        return message;
      } else {
        // 非语音交互模式或立即添加：直接添加到聊天列表
        if (this.aiChatMessages) {
          this.aiChatMessages.push(message);
          console.log('[mixin] 消息已添加到聊天列表，当前数量:', this.aiChatMessages.length);
        }
        return message;
      }
    },

      // 处理语音交互模式下的消息完成
  finalizeVoiceInteractionMessage(options = {}) {
    const {
      voiceInteractionMode = false,
      clearCurrentMessage = true,
      insertToChat = false
    } = options;

    if (voiceInteractionMode && this.currentMessage) {
      console.log('[mixin] 语音交互模式，处理临时消息完成');
      
      // 只有在明确要求时才插入到聊天列表
      if (insertToChat && this.aiChatMessages) {
        console.log('[mixin] 将临时消息插入到聊天列表');
        this.aiChatMessages.push(this.currentMessage);
        console.log('[mixin] 临时消息已插入到聊天列表，当前消息数量:', this.aiChatMessages.length);
      }
      
      if (clearCurrentMessage) {
        this.currentMessage = null;
      }
      
      return true;
    }
    
    return false;
  },

    // 生成UUID的辅助方法
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
  },
  created(){
    
  },
  beforeDestroy() {
    if (this.wavesurfer) {
      this.wavesurfer.destroy();
      this.wavesurfer = null;
      this.record = null;
    }
  },
};
